/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export var OriOnlineWebApiV2ConceptIndexItemsConceptIndexItemDto = {
    serializedName: "OriOnlineWebApiV2ConceptIndexItemsConceptIndexItemDto",
    type: {
        name: "Composite",
        className: "OriOnlineWebApiV2ConceptIndexItemsConceptIndexItemDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            isConsultantsOnly: {
                required: true,
                serializedName: "IsConsultantsOnly",
                type: {
                    name: "Boolean"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsAdverseReactionProductAdrDto = {
    serializedName: "StaticApplicationsAdverseReactionProductAdrDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsAdverseReactionProductAdrDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            itemType: {
                serializedName: "ItemType",
                type: {
                    name: "String"
                }
            },
            itemCategory: {
                serializedName: "ItemCategory",
                type: {
                    name: "String"
                }
            },
            hexColor: {
                serializedName: "HexColor",
                type: {
                    name: "String"
                }
            },
            displayShadeName: {
                serializedName: "DisplayShadeName",
                type: {
                    name: "String"
                }
            },
            imageId: {
                serializedName: "ImageId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsAdvisorNovAgeSkincareConfigurationDto = {
    serializedName: "StaticApplicationsAdvisorNovAgeSkincareConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsAdvisorNovAgeSkincareConfigurationDto",
        modelProperties: {
            partnerId: {
                serializedName: "PartnerId",
                type: {
                    name: "String"
                }
            },
            enviroment: {
                serializedName: "Enviroment",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedAttributeDto = {
    serializedName: "StaticSharedAttributeDto",
    type: {
        name: "Composite",
        className: "StaticSharedAttributeDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            value: {
                serializedName: "Value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedLinkDto = {
    serializedName: "StaticSharedLinkDto",
    type: {
        name: "Composite",
        className: "StaticSharedLinkDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            attributes: {
                required: true,
                serializedName: "Attributes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedAttributeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsBreadcrumbsBreadcrumbsDto = {
    serializedName: "StaticApplicationsBreadcrumbsBreadcrumbsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsBreadcrumbsBreadcrumbsDto",
        modelProperties: {
            links: {
                required: true,
                serializedName: "Links",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedLinkDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsCatalogueIPaperConfigurationCatalogueIPaperConfigurationDto = {
    serializedName: "StaticApplicationsCatalogueIPaperConfigurationCatalogueIPaperConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsCatalogueIPaperConfigurationCatalogueIPaperConfigurationDto",
        modelProperties: {
            catalogueUrl: {
                serializedName: "CatalogueUrl",
                type: {
                    name: "String"
                }
            },
            downloadEnabled: {
                required: true,
                serializedName: "DownloadEnabled",
                type: {
                    name: "Boolean"
                }
            },
            sharingEnabled: {
                required: true,
                serializedName: "SharingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            quickBuyEnabled: {
                required: true,
                serializedName: "QuickBuyEnabled",
                type: {
                    name: "Boolean"
                }
            },
            productInfoDialogEnabled: {
                required: true,
                serializedName: "ProductInfoDialogEnabled",
                type: {
                    name: "Boolean"
                }
            },
            fullScreenEnabled: {
                required: true,
                serializedName: "FullScreenEnabled",
                type: {
                    name: "Boolean"
                }
            },
            apiBaseUrl: {
                serializedName: "ApiBaseUrl",
                type: {
                    name: "String"
                }
            },
            apiSecret: {
                serializedName: "ApiSecret",
                type: {
                    name: "String"
                }
            },
            sharingCatalogueEnabled: {
                required: true,
                serializedName: "SharingCatalogueEnabled",
                type: {
                    name: "Boolean"
                }
            },
            sharingPageEnabled: {
                required: true,
                serializedName: "SharingPageEnabled",
                type: {
                    name: "Boolean"
                }
            },
            sharingOfflineCatalogueEnabled: {
                required: true,
                serializedName: "SharingOfflineCatalogueEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsCatalogueOverviewCataloguMetadataDto = {
    serializedName: "StaticApplicationsCatalogueOverviewCataloguMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsCatalogueOverviewCataloguMetadataDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            providerType: {
                required: true,
                serializedName: "ProviderType",
                type: {
                    name: "String"
                }
            },
            urlLabel: {
                serializedName: "UrlLabel",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsCatalogueOverviewValidityPeriodDto = {
    serializedName: "StaticApplicationsCatalogueOverviewValidityPeriodDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsCatalogueOverviewValidityPeriodDto",
        modelProperties: {
            from: {
                required: true,
                serializedName: "From",
                type: {
                    name: "DateTime"
                }
            },
            to: {
                required: true,
                serializedName: "To",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticApplicationsCatalogueOverviewCatalogueDto = {
    serializedName: "StaticApplicationsCatalogueOverviewCatalogueDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsCatalogueOverviewCatalogueDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            catalogueType: {
                required: true,
                serializedName: "CatalogueType",
                type: {
                    name: "String"
                }
            },
            metadataCollection: {
                required: true,
                serializedName: "MetadataCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsCatalogueOverviewCataloguMetadataDto"
                        }
                    }
                }
            },
            valid: {
                serializedName: "Valid",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsCatalogueOverviewValidityPeriodDto"
                }
            }
        }
    }
};
export var StaticApplicationsCatalogueOverviewCatalogueOverviewDto = {
    serializedName: "StaticApplicationsCatalogueOverviewCatalogueOverviewDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsCatalogueOverviewCatalogueOverviewDto",
        modelProperties: {
            catalogues: {
                required: true,
                serializedName: "Catalogues",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsCatalogueOverviewCatalogueDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsChatBotChatBotMetadataDto = {
    serializedName: "StaticApplicationsChatBotChatBotMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsChatBotChatBotMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormConfigurationInputTextLimitsDto = {
    serializedName: "StaticApplicationsConcernReportFormConfigurationInputTextLimitsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormConfigurationInputTextLimitsDto",
        modelProperties: {
            characterLimitForATextBox: {
                required: true,
                serializedName: "CharacterLimitForATextBox",
                type: {
                    name: "Number"
                }
            },
            characterLimitForATextArea: {
                required: true,
                serializedName: "CharacterLimitForATextArea",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormConfigurationEmailServiceDto = {
    serializedName: "StaticApplicationsConcernReportFormConfigurationEmailServiceDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormConfigurationEmailServiceDto",
        modelProperties: {
            maximumNumberOfAttachments: {
                required: true,
                serializedName: "MaximumNumberOfAttachments",
                type: {
                    name: "Number"
                }
            },
            fileSizeLimitInMBs: {
                required: true,
                serializedName: "FileSizeLimitInMBs",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormConfigurationReCaptchaDto = {
    serializedName: "StaticApplicationsConcernReportFormConfigurationReCaptchaDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormConfigurationReCaptchaDto",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            siteKey: {
                serializedName: "SiteKey",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormConfigurationConcernReportFormConfigurationDto = {
    serializedName: "StaticApplicationsConcernReportFormConfigurationConcernReportFormConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormConfigurationConcernReportFormConfigurationDto",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            inputTextLimits: {
                serializedName: "InputTextLimits",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormConfigurationInputTextLimitsDto"
                }
            },
            emailService: {
                serializedName: "EmailService",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormConfigurationEmailServiceDto"
                }
            },
            reCaptcha: {
                serializedName: "ReCaptcha",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormConfigurationReCaptchaDto"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationAttachmentsTableDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationAttachmentsTableDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationAttachmentsTableDto",
        modelProperties: {
            size: {
                serializedName: "Size",
                type: {
                    name: "String"
                }
            },
            attachment: {
                serializedName: "Attachment",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationComponentsLabelsDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationComponentsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationComponentsLabelsDto",
        modelProperties: {
            radioButtonYes: {
                serializedName: "RadioButtonYes",
                type: {
                    name: "String"
                }
            },
            radioButtonNo: {
                serializedName: "RadioButtonNo",
                type: {
                    name: "String"
                }
            },
            addAttachmentButton: {
                serializedName: "AddAttachmentButton",
                type: {
                    name: "String"
                }
            },
            sendButton: {
                serializedName: "SendButton",
                type: {
                    name: "String"
                }
            },
            generatePdfButton: {
                serializedName: "GeneratePdfButton",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationIntroductionDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationIntroductionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationIntroductionDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationQuestionDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationQuestionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationQuestionDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationNotificationLabelsDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationNotificationLabelsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationNotificationLabelsDto",
        modelProperties: {
            attachmentAdded: {
                serializedName: "AttachmentAdded",
                type: {
                    name: "String"
                }
            },
            attachmentRemoved: {
                serializedName: "AttachmentRemoved",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationValidationLabelsDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationValidationLabelsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationValidationLabelsDto",
        modelProperties: {
            fileTypeNotSupported: {
                serializedName: "FileTypeNotSupported",
                type: {
                    name: "String"
                }
            },
            fileTooLarge: {
                serializedName: "FileTooLarge",
                type: {
                    name: "String"
                }
            },
            questionRequired: {
                serializedName: "QuestionRequired",
                type: {
                    name: "String"
                }
            },
            tooManyCharactersMaximumIs: {
                serializedName: "TooManyCharactersMaximumIs",
                type: {
                    name: "String"
                }
            },
            maximumNumberOfFiles: {
                serializedName: "MaximumNumberOfFiles",
                type: {
                    name: "String"
                }
            },
            maximumFileSize: {
                serializedName: "MaximumFileSize",
                type: {
                    name: "String"
                }
            },
            allowedFileTypes: {
                serializedName: "AllowedFileTypes",
                type: {
                    name: "String"
                }
            },
            required: {
                serializedName: "Required",
                type: {
                    name: "String"
                }
            },
            enterResponse: {
                serializedName: "EnterResponse",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsConcernReportFormLocalizationConcernReportFormLocalizationDto = {
    serializedName: "StaticApplicationsConcernReportFormLocalizationConcernReportFormLocalizationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsConcernReportFormLocalizationConcernReportFormLocalizationDto",
        modelProperties: {
            introduction: {
                serializedName: "Introduction",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormLocalizationIntroductionDto"
                }
            },
            questions: {
                required: true,
                serializedName: "Questions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsConcernReportFormLocalizationQuestionDto"
                        }
                    }
                }
            },
            componentsLabels: {
                serializedName: "ComponentsLabels",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormLocalizationComponentsLabelsDto"
                }
            },
            notificationLabels: {
                serializedName: "NotificationLabels",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormLocalizationNotificationLabelsDto"
                }
            },
            validationLabels: {
                serializedName: "ValidationLabels",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormLocalizationValidationLabelsDto"
                }
            },
            attachmentsTable: {
                serializedName: "AttachmentsTable",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsConcernReportFormLocalizationAttachmentsTableDto"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialArticleCarouselDto = {
    serializedName: "StaticApplicationsEditorialArticleCarouselDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialArticleCarouselDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            showEditorialArticlesForRelatedProducts: {
                required: true,
                serializedName: "ShowEditorialArticlesForRelatedProducts",
                type: {
                    name: "Boolean"
                }
            },
            articleIds: {
                required: true,
                serializedName: "ArticleIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialArticleCarouselCollectionDto = {
    serializedName: "StaticApplicationsEditorialArticleCarouselCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialArticleCarouselCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialArticleCarouselDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialBackgroundColorDto = {
    serializedName: "StaticApplicationsEditorialBackgroundColorDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialBackgroundColorDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialBackgroundImageDto = {
    serializedName: "StaticApplicationsEditorialBackgroundImageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialBackgroundImageDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialBackgroundVideoDto = {
    serializedName: "StaticApplicationsEditorialBackgroundVideoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialBackgroundVideoDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            autoplayOnScroll: {
                required: true,
                serializedName: "AutoplayOnScroll",
                type: {
                    name: "Boolean"
                }
            },
            playInLoop: {
                required: true,
                serializedName: "PlayInLoop",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialContentDto = {
    serializedName: "StaticApplicationsEditorialContentDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialContentDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialTextDto = {
    serializedName: "StaticApplicationsEditorialTextDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialTextDto",
        modelProperties: {
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialBannerContentDto = {
    serializedName: "StaticApplicationsEditorialEditorialBannerContentDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialBannerContentDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            textCollection: {
                required: true,
                serializedName: "TextCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialTextDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialBannerModuleDto = {
    serializedName: "StaticApplicationsEditorialEditorialBannerModuleDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialBannerModuleDto",
        modelProperties: {
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            backgroundType: {
                required: true,
                serializedName: "BackgroundType",
                type: {
                    name: "String"
                }
            },
            backgroundVideo: {
                serializedName: "BackgroundVideo",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsEditorialBackgroundVideoDto"
                }
            },
            backgroundImage: {
                serializedName: "BackgroundImage",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsEditorialBackgroundImageDto"
                }
            },
            backgroundColor: {
                serializedName: "BackgroundColor",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsEditorialBackgroundColorDto"
                }
            },
            content: {
                serializedName: "Content",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsEditorialEditorialBannerContentDto"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialBannerDto = {
    serializedName: "StaticApplicationsEditorialEditorialBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialBannerDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            layout: {
                required: true,
                serializedName: "Layout",
                type: {
                    name: "String"
                }
            },
            modules: {
                required: true,
                serializedName: "Modules",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialEditorialBannerModuleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialBannerCollectionDto = {
    serializedName: "StaticApplicationsEditorialEditorialBannerCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialBannerCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialEditorialBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialPageDto = {
    serializedName: "StaticApplicationsEditorialEditorialPageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialPageDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            contentItems: {
                required: true,
                serializedName: "ContentItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialContentDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialEditorialPagesCollectionDto = {
    serializedName: "StaticApplicationsEditorialEditorialPagesCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialEditorialPagesCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialEditorialPageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialHeaderDto = {
    serializedName: "StaticApplicationsEditorialHeaderDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialHeaderDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            publishedDate: {
                required: true,
                serializedName: "PublishedDate",
                type: {
                    name: "DateTime"
                }
            },
            authorName: {
                serializedName: "AuthorName",
                type: {
                    name: "String"
                }
            },
            photographerName: {
                serializedName: "PhotographerName",
                type: {
                    name: "String"
                }
            },
            isSharingEnabled: {
                required: true,
                serializedName: "IsSharingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            links: {
                required: true,
                serializedName: "Links",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedLinkDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialHeaderCollectionDto = {
    serializedName: "StaticApplicationsEditorialHeaderCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialHeaderCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialHeaderDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialOlapicDto = {
    serializedName: "StaticApplicationsEditorialOlapicDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialOlapicDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            categoryId: {
                serializedName: "CategoryId",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsEditorialOlapicCollectionDto = {
    serializedName: "StaticApplicationsEditorialOlapicCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialOlapicCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialOlapicDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialProductBoxCarouselDto = {
    serializedName: "StaticApplicationsEditorialProductBoxCarouselDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialProductBoxCarouselDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            usePopularProductForCategories: {
                required: true,
                serializedName: "UsePopularProductForCategories",
                type: {
                    name: "Boolean"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsEditorialProductBoxCarouselCollectionDto = {
    serializedName: "StaticApplicationsEditorialProductBoxCarouselCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsEditorialProductBoxCarouselCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsEditorialProductBoxCarouselDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsExternalCampaignsExternalCampaignDto = {
    serializedName: "StaticApplicationsExternalCampaignsExternalCampaignDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsExternalCampaignsExternalCampaignDto",
        modelProperties: {
            campaignUrl: {
                serializedName: "CampaignUrl",
                type: {
                    name: "String"
                }
            },
            campaignId: {
                serializedName: "CampaignId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsExternalCampaignsExternalCampaignsCollectionDto = {
    serializedName: "StaticApplicationsExternalCampaignsExternalCampaignsCollectionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsExternalCampaignsExternalCampaignsCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsExternalCampaignsExternalCampaignDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffNavigationItemDto = {
    serializedName: "StaticApplicationsFooterBffNavigationItemDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffNavigationItemDto",
        modelProperties: {
            linkType: {
                required: true,
                serializedName: "LinkType",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffNavigationDto = {
    serializedName: "StaticApplicationsFooterBffNavigationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffNavigationDto",
        modelProperties: {
            navigationType: {
                required: true,
                serializedName: "NavigationType",
                type: {
                    name: "String"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffLanguageConfigurationDto = {
    serializedName: "StaticApplicationsFooterBffLanguageConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffLanguageConfigurationDto",
        modelProperties: {
            currentCountry: {
                serializedName: "CurrentCountry",
                type: {
                    name: "String"
                }
            },
            languageLabel: {
                serializedName: "LanguageLabel",
                type: {
                    name: "String"
                }
            },
            countryLabel: {
                serializedName: "CountryLabel",
                type: {
                    name: "String"
                }
            },
            selectCountryLabel: {
                serializedName: "SelectCountryLabel",
                type: {
                    name: "String"
                }
            },
            selectCountryUrl: {
                serializedName: "SelectCountryUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffApplicationApplicationFooterDto = {
    serializedName: "StaticApplicationsFooterBffApplicationApplicationFooterDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffApplicationApplicationFooterDto",
        modelProperties: {
            languageConfiguration: {
                serializedName: "LanguageConfiguration",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffLanguageConfigurationDto"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffApplicationApplicationDto = {
    serializedName: "StaticApplicationsFooterBffApplicationApplicationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffApplicationApplicationDto",
        modelProperties: {
            navigations: {
                required: true,
                serializedName: "Navigations",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffNavigationDto"
                        }
                    }
                }
            },
            footer: {
                serializedName: "Footer",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffApplicationApplicationFooterDto"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffErrorDialogDto = {
    serializedName: "StaticApplicationsFooterBffErrorDialogDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffErrorDialogDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            buttonText: {
                serializedName: "ButtonText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffNewsletterFooterDto = {
    serializedName: "StaticApplicationsFooterBffNewsletterFooterDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffNewsletterFooterDto",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffPopupDto = {
    serializedName: "StaticApplicationsFooterBffPopupDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffPopupDto",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            delayInSeconds: {
                required: true,
                serializedName: "DelayInSeconds",
                type: {
                    name: "Number"
                }
            },
            displayFrequencyInDays: {
                required: true,
                serializedName: "DisplayFrequencyInDays",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffSubmitDialogDto = {
    serializedName: "StaticApplicationsFooterBffSubmitDialogDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffSubmitDialogDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            emailLabel: {
                serializedName: "EmailLabel",
                type: {
                    name: "String"
                }
            },
            invalidEmailLabel: {
                serializedName: "InvalidEmailLabel",
                type: {
                    name: "String"
                }
            },
            subscribeButtonText: {
                serializedName: "SubscribeButtonText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyText: {
                serializedName: "PrivacyPolicyText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyUrlText: {
                serializedName: "PrivacyPolicyUrlText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyUrl: {
                serializedName: "PrivacyPolicyUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffSubscribedDialogDto = {
    serializedName: "StaticApplicationsFooterBffSubscribedDialogDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffSubscribedDialogDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffResponseMessageDto = {
    serializedName: "StaticApplicationsFooterBffResponseMessageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffResponseMessageDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto = {
    serializedName: "StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto",
        modelProperties: {
            footer: {
                serializedName: "Footer",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffNewsletterFooterDto"
                }
            },
            popup: {
                serializedName: "Popup",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffPopupDto"
                }
            },
            submitDialog: {
                serializedName: "SubmitDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffSubmitDialogDto"
                }
            },
            subscribedDialog: {
                serializedName: "SubscribedDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffSubscribedDialogDto"
                }
            },
            errorDialog: {
                serializedName: "ErrorDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffErrorDialogDto"
                }
            },
            responseMessages: {
                required: true,
                serializedName: "ResponseMessages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffResponseMessageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffSocialMediaLinkDto = {
    serializedName: "StaticApplicationsFooterBffSocialMediaLinkDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffSocialMediaLinkDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffLanguageDto = {
    serializedName: "StaticApplicationsFooterBffLanguageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffLanguageDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffMobileAppMobileAppTypeDto = {
    serializedName: "StaticApplicationsFooterBffMobileAppMobileAppTypeDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffMobileAppMobileAppTypeDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffMobileAppMobileAppLinksDto = {
    serializedName: "StaticApplicationsFooterBffMobileAppMobileAppLinksDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffMobileAppMobileAppLinksDto",
        modelProperties: {
            googlePlayStoreLink: {
                serializedName: "GooglePlayStoreLink",
                type: {
                    name: "String"
                }
            },
            appleStoreLink: {
                serializedName: "AppleStoreLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffMobileAppMobileAppItemDto = {
    serializedName: "StaticApplicationsFooterBffMobileAppMobileAppItemDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffMobileAppMobileAppItemDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            titleImage: {
                serializedName: "TitleImage",
                type: {
                    name: "String"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            mobileAppType: {
                serializedName: "MobileAppType",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffMobileAppMobileAppTypeDto"
                }
            },
            links: {
                serializedName: "Links",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffMobileAppMobileAppLinksDto"
                }
            }
        }
    }
};
export var StaticApplicationsFooterBffFooterDto = {
    serializedName: "StaticApplicationsFooterBffFooterDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterBffFooterDto",
        modelProperties: {
            newsletterSubsciptionConfiguration: {
                serializedName: "NewsletterSubsciptionConfiguration",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto"
                }
            },
            socialMediaLinks: {
                required: true,
                serializedName: "SocialMediaLinks",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffSocialMediaLinkDto"
                        }
                    }
                }
            },
            applications: {
                serializedName: "Applications",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffApplicationApplicationDto"
                }
            },
            languages: {
                required: true,
                serializedName: "Languages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFooterBffLanguageDto"
                        }
                    }
                }
            },
            mobileApps: {
                serializedName: "MobileApps",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffMobileAppMobileAppItemDto"
                }
            }
        }
    }
};
export var StaticApplicationsFooterLanguageConfigurationLanguageConfigurationDto = {
    serializedName: "StaticApplicationsFooterLanguageConfigurationLanguageConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFooterLanguageConfigurationLanguageConfigurationDto",
        modelProperties: {
            currentCountry: {
                serializedName: "CurrentCountry",
                type: {
                    name: "String"
                }
            },
            languageLabel: {
                serializedName: "LanguageLabel",
                type: {
                    name: "String"
                }
            },
            countryLabel: {
                serializedName: "CountryLabel",
                type: {
                    name: "String"
                }
            },
            selectCountryLabel: {
                serializedName: "SelectCountryLabel",
                type: {
                    name: "String"
                }
            },
            selectCountryUrl: {
                serializedName: "SelectCountryUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BeautyEditDto = {
    serializedName: "StaticApplicationsFrontpageV3BeautyEditDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BeautyEditDto",
        modelProperties: {
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3VideoDto = {
    serializedName: "StaticApplicationsFrontpageV3VideoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3VideoDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            autoplayOnScroll: {
                required: true,
                serializedName: "AutoplayOnScroll",
                type: {
                    name: "Boolean"
                }
            },
            playInLoop: {
                required: true,
                serializedName: "PlayInLoop",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BeautyVideoDto = {
    serializedName: "StaticApplicationsFrontpageV3BeautyVideoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BeautyVideoDto",
        modelProperties: {
            video: {
                serializedName: "Video",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3VideoDto"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BenefitBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BenefitBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BenefitBannerDto",
        modelProperties: {
            messageTitle: {
                serializedName: "MessageTitle",
                type: {
                    name: "String"
                }
            },
            messageUrl: {
                serializedName: "MessageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffMotivationContentDto = {
    serializedName: "StaticApplicationsFrontpageV3BffMotivationContentDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffMotivationContentDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffLogoDto = {
    serializedName: "StaticApplicationsFrontpageV3BffLogoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffLogoDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBrandDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBrandDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBrandDto",
        modelProperties: {
            logo: {
                serializedName: "Logo",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLogoDto"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffTopBrandsDto = {
    serializedName: "StaticApplicationsFrontpageV3BffTopBrandsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffTopBrandsDto",
        modelProperties: {
            topBrandTitle: {
                serializedName: "TopBrandTitle",
                type: {
                    name: "String"
                }
            },
            brands: {
                required: true,
                serializedName: "Brands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffVideoDto = {
    serializedName: "StaticApplicationsFrontpageV3BffVideoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffVideoDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            playInLoop: {
                required: true,
                serializedName: "PlayInLoop",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffLinkDto = {
    serializedName: "StaticApplicationsFrontpageV3BffLinkDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffLinkDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            relativeUrl: {
                serializedName: "RelativeUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBeautyVideoDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBeautyVideoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBeautyVideoDto",
        modelProperties: {
            video: {
                serializedName: "Video",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffVideoDto"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffProductStandardsImageDto = {
    serializedName: "StaticApplicationsFrontpageV3BffProductStandardsImageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffProductStandardsImageDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subTitle: {
                serializedName: "SubTitle",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffProductStandardsDto = {
    serializedName: "StaticApplicationsFrontpageV3BffProductStandardsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffProductStandardsDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffProductStandardsImageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffVipBenefitsImageDto = {
    serializedName: "StaticApplicationsFrontpageV3BffVipBenefitsImageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffVipBenefitsImageDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            alt: {
                serializedName: "Alt",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffVipBenefitsDto = {
    serializedName: "StaticApplicationsFrontpageV3BffVipBenefitsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffVipBenefitsDto",
        modelProperties: {
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffVipBenefitsImageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffEditorialArticleDto = {
    serializedName: "StaticApplicationsFrontpageV3BffEditorialArticleDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffEditorialArticleDto",
        modelProperties: {
            categoryTitle: {
                serializedName: "CategoryTitle",
                type: {
                    name: "String"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffVipBenefitsImageDto"
                        }
                    }
                }
            },
            introText: {
                serializedName: "IntroText",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBeautyEditDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBeautyEditDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBeautyEditDto",
        modelProperties: {
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            editorialArticles: {
                required: true,
                serializedName: "EditorialArticles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffEditorialArticleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffNavigationItemDto = {
    serializedName: "StaticApplicationsFrontpageV3BffNavigationItemDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffNavigationItemDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            relativeUrl: {
                serializedName: "RelativeUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBenefitBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBenefitBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBenefitBannerDto",
        modelProperties: {
            messageTitle: {
                serializedName: "MessageTitle",
                type: {
                    name: "String"
                }
            },
            messageUrl: {
                serializedName: "MessageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffHeroBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffHeroBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffHeroBannerDto",
        modelProperties: {
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            },
            priority: {
                required: true,
                serializedName: "Priority",
                type: {
                    name: "Number"
                }
            },
            smallImageUrl: {
                serializedName: "SmallImageUrl",
                type: {
                    name: "String"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBestOffersBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBestOffersBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBestOffersBannerDto",
        modelProperties: {
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto",
        modelProperties: {
            showBackInStockNotification: {
                required: true,
                serializedName: "ShowBackInStockNotification",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffLabelDto = {
    serializedName: "StaticApplicationsFrontpageV3BffLabelDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffLabelDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            productLabelDomain: {
                serializedName: "ProductLabelDomain",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffProductDto = {
    serializedName: "StaticApplicationsFrontpageV3BffProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffProductDto",
        modelProperties: {
            colorHexCode: {
                serializedName: "ColorHexCode",
                type: {
                    name: "String"
                }
            },
            colorImageUrl: {
                serializedName: "ColorImageUrl",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffConceptDto = {
    serializedName: "StaticApplicationsFrontpageV3BffConceptDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffConceptDto",
        modelProperties: {
            brand: {
                serializedName: "Brand",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBrandDto"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            labels: {
                required: true,
                serializedName: "Labels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffLabelDto"
                        }
                    }
                }
            },
            productName: {
                serializedName: "ProductName",
                type: {
                    name: "String"
                }
            },
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffProductDto"
                        }
                    }
                }
            },
            ratingAverage: {
                required: true,
                serializedName: "RatingAverage",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffPriceDto = {
    serializedName: "StaticApplicationsFrontpageV3BffPriceDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "String"
                }
            },
            currentPrice: {
                serializedName: "CurrentPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffFormattedPriceDto = {
    serializedName: "StaticApplicationsFrontpageV3BffFormattedPriceDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffFormattedPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffPriceDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffPermissionDto = {
    serializedName: "StaticApplicationsFrontpageV3BffPermissionDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffPermissionDto",
        modelProperties: {
            canSell: {
                required: true,
                serializedName: "CanSell",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffBestOffersProductDto = {
    serializedName: "StaticApplicationsFrontpageV3BffBestOffersProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffBestOffersProductDto",
        modelProperties: {
            backInStockAvailability: {
                serializedName: "BackInStockAvailability",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto"
                }
            },
            concept: {
                serializedName: "Concept",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffConceptDto"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffFormattedPriceDto"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            permission: {
                serializedName: "Permission",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffPermissionDto"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffWhatsNewBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffWhatsNewBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffWhatsNewBannerDto",
        modelProperties: {
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffWhatsNewProductDto = {
    serializedName: "StaticApplicationsFrontpageV3BffWhatsNewProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffWhatsNewProductDto",
        modelProperties: {
            backInStockAvailability: {
                serializedName: "BackInStockAvailability",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto"
                }
            },
            concept: {
                serializedName: "Concept",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffConceptDto"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffFormattedPriceDto"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            permission: {
                serializedName: "Permission",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffPermissionDto"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffCategoryProductDto = {
    serializedName: "StaticApplicationsFrontpageV3BffCategoryProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffCategoryProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            concept: {
                serializedName: "Concept",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffConceptDto"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffFormattedPriceDto"
                }
            },
            backInStockAvailability: {
                serializedName: "BackInStockAvailability",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBackInStockAvailabilityDto"
                }
            },
            permission: {
                serializedName: "Permission",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffPermissionDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffCategoryBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffCategoryBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffCategoryBannerDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            shortText: {
                serializedName: "ShortText",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffCampaignBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffCampaignBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffCampaignBannerDto",
        modelProperties: {
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            },
            shortText: {
                serializedName: "ShortText",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffLinkDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffDigitalPromotionsDto = {
    serializedName: "StaticApplicationsFrontpageV3BffDigitalPromotionsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffDigitalPromotionsDto",
        modelProperties: {
            heroBanners: {
                required: true,
                serializedName: "HeroBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffHeroBannerDto"
                        }
                    }
                }
            },
            bestOffersBanners: {
                required: true,
                serializedName: "BestOffersBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffBestOffersBannerDto"
                        }
                    }
                }
            },
            bestOffersProducts: {
                required: true,
                serializedName: "BestOffersProducts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffBestOffersProductDto"
                        }
                    }
                }
            },
            whatsNewBanners: {
                required: true,
                serializedName: "WhatsNewBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffWhatsNewBannerDto"
                        }
                    }
                }
            },
            whatsNewProducts: {
                required: true,
                serializedName: "WhatsNewProducts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffWhatsNewProductDto"
                        }
                    }
                }
            },
            categoryProducts: {
                required: true,
                serializedName: "CategoryProducts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffCategoryProductDto"
                        }
                    }
                }
            },
            categoryBanners: {
                required: true,
                serializedName: "CategoryBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffCategoryBannerDto"
                        }
                    }
                }
            },
            campaignBanners: {
                required: true,
                serializedName: "CampaignBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffCampaignBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffFrontPageDataDto = {
    serializedName: "StaticApplicationsFrontpageV3BffFrontPageDataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffFrontPageDataDto",
        modelProperties: {
            motivationContent: {
                serializedName: "MotivationContent",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffMotivationContentDto"
                }
            },
            topBrands: {
                serializedName: "TopBrands",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffTopBrandsDto"
                }
            },
            beautyVideo: {
                serializedName: "BeautyVideo",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBeautyVideoDto"
                }
            },
            productStandards: {
                serializedName: "ProductStandards",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffProductStandardsDto"
                }
            },
            vipBenefits: {
                serializedName: "VipBenefits",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffVipBenefitsDto"
                }
            },
            beautyEdit: {
                serializedName: "BeautyEdit",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBeautyEditDto"
                }
            },
            categoryNavigation: {
                required: true,
                serializedName: "CategoryNavigation",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3BffNavigationItemDto"
                        }
                    }
                }
            },
            benefitBanner: {
                serializedName: "BenefitBanner",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffBenefitBannerDto"
                }
            },
            digitalPromotions: {
                serializedName: "DigitalPromotions",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffDigitalPromotionsDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffApplicationDto = {
    serializedName: "StaticApplicationsFrontpageV3BffApplicationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffApplicationDto",
        modelProperties: {
            frontpage: {
                serializedName: "Frontpage",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffFrontPageDataDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffVipCustomerBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3BffVipCustomerBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffVipCustomerBannerDto",
        modelProperties: {
            linkTitle: {
                serializedName: "LinkTitle",
                type: {
                    name: "String"
                }
            },
            linkUrl: {
                serializedName: "LinkUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3BffFrontPageDto = {
    serializedName: "StaticApplicationsFrontpageV3BffFrontPageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3BffFrontPageDto",
        modelProperties: {
            application: {
                serializedName: "Application",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffApplicationDto"
                }
            },
            vipCustomerBanner: {
                serializedName: "VipCustomerBanner",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffVipCustomerBannerDto"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3MotivationContentDto = {
    serializedName: "StaticApplicationsFrontpageV3MotivationContentDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3MotivationContentDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3NotificationBannerDto = {
    serializedName: "StaticApplicationsFrontpageV3NotificationBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3NotificationBannerDto",
        modelProperties: {
            messageLinkUrl: {
                serializedName: "MessageLinkUrl",
                type: {
                    name: "String"
                }
            },
            messageLinkTitle: {
                serializedName: "MessageLinkTitle",
                type: {
                    name: "String"
                }
            },
            messageText: {
                serializedName: "MessageText",
                type: {
                    name: "String"
                }
            },
            messageTheme: {
                required: true,
                serializedName: "MessageTheme",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3ProductStandardsImageDto = {
    serializedName: "StaticApplicationsFrontpageV3ProductStandardsImageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3ProductStandardsImageDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3ProductStandardsDto = {
    serializedName: "StaticApplicationsFrontpageV3ProductStandardsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3ProductStandardsDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3ProductStandardsImageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3TopBrandDto = {
    serializedName: "StaticApplicationsFrontpageV3TopBrandDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3TopBrandDto",
        modelProperties: {
            taxonomyId: {
                serializedName: "TaxonomyId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3TopBrandsDto = {
    serializedName: "StaticApplicationsFrontpageV3TopBrandsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3TopBrandsDto",
        modelProperties: {
            topBrandsTitle: {
                serializedName: "TopBrandsTitle",
                type: {
                    name: "String"
                }
            },
            topBrandsCollection: {
                required: true,
                serializedName: "TopBrandsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3TopBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3VipBenefitsImageDto = {
    serializedName: "StaticApplicationsFrontpageV3VipBenefitsImageDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3VipBenefitsImageDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsFrontpageV3VipBenefitsDto = {
    serializedName: "StaticApplicationsFrontpageV3VipBenefitsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsFrontpageV3VipBenefitsDto",
        modelProperties: {
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsFrontpageV3VipBenefitsImageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsGenesysWidgetGenesysWidgetMetadataDto = {
    serializedName: "StaticApplicationsGenesysWidgetGenesysWidgetMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsGenesysWidgetGenesysWidgetMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            isPredictiveFeatureEnabled: {
                required: true,
                serializedName: "IsPredictiveFeatureEnabled",
                type: {
                    name: "Boolean"
                }
            },
            isMobileWidgetEnabled: {
                required: true,
                serializedName: "IsMobileWidgetEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSharedClientOptionDto = {
    serializedName: "StaticSharedClientOptionDto",
    type: {
        name: "Composite",
        className: "StaticSharedClientOptionDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsGenesysWidgetGenesysWidgetPageMetadataDto = {
    serializedName: "StaticApplicationsGenesysWidgetGenesysWidgetPageMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsGenesysWidgetGenesysWidgetPageMetadataDto",
        modelProperties: {
            genesysWidget: {
                serializedName: "GenesysWidget",
                type: {
                    name: "Composite",
                    className: "StaticSharedClientOptionDto"
                }
            }
        }
    }
};
export var StaticApplicationsGuaranteeCreditGrantedCreditConfigurationDto = {
    serializedName: "StaticApplicationsGuaranteeCreditGrantedCreditConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsGuaranteeCreditGrantedCreditConfigurationDto",
        modelProperties: {
            permanentCreditAllowed: {
                required: true,
                serializedName: "PermanentCreditAllowed",
                type: {
                    name: "Boolean"
                }
            },
            permanentCreditLimit: {
                required: true,
                serializedName: "PermanentCreditLimit",
                type: {
                    name: "Number"
                }
            },
            oneTimeCreditAllowed: {
                required: true,
                serializedName: "OneTimeCreditAllowed",
                type: {
                    name: "Boolean"
                }
            },
            oneTimeCreditLimit: {
                required: true,
                serializedName: "OneTimeCreditLimit",
                type: {
                    name: "Number"
                }
            },
            checkGuarantorRemainingCredit: {
                required: true,
                serializedName: "CheckGuarantorRemainingCredit",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsMakeupTryOnProductDetailDto = {
    serializedName: "StaticApplicationsMakeupTryOnProductDetailDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsMakeupTryOnProductDetailDto",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            tryItOnLabel: {
                serializedName: "TryItOnLabel",
                type: {
                    name: "String"
                }
            },
            allowsLiveCameraLabel: {
                serializedName: "AllowsLiveCameraLabel",
                type: {
                    name: "String"
                }
            },
            shiShiComponentUrl: {
                serializedName: "ShiShiComponentUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsMakeupTryOnMakeupTryOnConfigurationDto = {
    serializedName: "StaticApplicationsMakeupTryOnMakeupTryOnConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsMakeupTryOnMakeupTryOnConfigurationDto",
        modelProperties: {
            productDetail: {
                serializedName: "ProductDetail",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsMakeupTryOnProductDetailDto"
                }
            }
        }
    }
};
export var StaticApplicationsMakeupTryOnMakeupTryOnProductRelationDto = {
    serializedName: "StaticApplicationsMakeupTryOnMakeupTryOnProductRelationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsMakeupTryOnMakeupTryOnProductRelationDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            shiShiProductId: {
                serializedName: "ShiShiProductId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsMakeupTryOnMakeupTryOnProductsRelationsDto = {
    serializedName: "StaticApplicationsMakeupTryOnMakeupTryOnProductsRelationsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsMakeupTryOnMakeupTryOnProductsRelationsDto",
        modelProperties: {
            makeupTryOnProductRelationCollection: {
                required: true,
                serializedName: "MakeupTryOnProductRelationCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsMakeupTryOnMakeupTryOnProductRelationDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationErrorDialog = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationErrorDialog",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationErrorDialog",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            buttonText: {
                serializedName: "ButtonText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationFooter = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationFooter",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationFooter",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationPopup = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationPopup",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationPopup",
        modelProperties: {
            enabled: {
                required: true,
                serializedName: "Enabled",
                type: {
                    name: "Boolean"
                }
            },
            delayInSeconds: {
                required: true,
                serializedName: "DelayInSeconds",
                type: {
                    name: "Number"
                }
            },
            displayFrequencyInDays: {
                required: true,
                serializedName: "DisplayFrequencyInDays",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationSubmitDialog = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationSubmitDialog",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationSubmitDialog",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            emailLabel: {
                serializedName: "EmailLabel",
                type: {
                    name: "String"
                }
            },
            invalidEmailLabel: {
                serializedName: "InvalidEmailLabel",
                type: {
                    name: "String"
                }
            },
            subscribeButtonText: {
                serializedName: "SubscribeButtonText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyText: {
                serializedName: "PrivacyPolicyText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyUrlText: {
                serializedName: "PrivacyPolicyUrlText",
                type: {
                    name: "String"
                }
            },
            privacyPolicyUrl: {
                serializedName: "PrivacyPolicyUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationSubscribedDialog = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationSubscribedDialog",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationSubscribedDialog",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationResponseMessage = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationResponseMessage",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationResponseMessage",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsNewsletterSubsciptionConfigurationNewsletterSubscriptionConfigurationDto = {
    serializedName: "StaticApplicationsNewsletterSubsciptionConfigurationNewsletterSubscriptionConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsNewsletterSubsciptionConfigurationNewsletterSubscriptionConfigurationDto",
        modelProperties: {
            footer: {
                serializedName: "Footer",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsNewsletterSubsciptionConfigurationFooter"
                }
            },
            popup: {
                serializedName: "Popup",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsNewsletterSubsciptionConfigurationPopup"
                }
            },
            submitDialog: {
                serializedName: "SubmitDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsNewsletterSubsciptionConfigurationSubmitDialog"
                }
            },
            subscribedDialog: {
                serializedName: "SubscribedDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsNewsletterSubsciptionConfigurationSubscribedDialog"
                }
            },
            errorDialog: {
                serializedName: "ErrorDialog",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsNewsletterSubsciptionConfigurationErrorDialog"
                }
            },
            responseMessages: {
                required: true,
                serializedName: "ResponseMessages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsNewsletterSubsciptionConfigurationResponseMessage"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxBackInStockAvailabilityDto = {
    serializedName: "StaticApplicationsProductBoxBackInStockAvailabilityDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxBackInStockAvailabilityDto",
        modelProperties: {
            showBackInStockNotification: {
                required: true,
                serializedName: "ShowBackInStockNotification",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxBrandDto = {
    serializedName: "StaticApplicationsProductBoxBrandDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxBrandDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxLabelsDto = {
    serializedName: "StaticApplicationsProductBoxLabelsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxLabelsDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            productLabelDomain: {
                serializedName: "ProductLabelDomain",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxConceptProductDto = {
    serializedName: "StaticApplicationsProductBoxConceptProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxConceptProductDto",
        modelProperties: {
            colorHexCode: {
                serializedName: "ColorHexCode",
                type: {
                    name: "String"
                }
            },
            colorImageUrl: {
                serializedName: "ColorImageUrl",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxConceptDto = {
    serializedName: "StaticApplicationsProductBoxConceptDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxConceptDto",
        modelProperties: {
            brand: {
                serializedName: "Brand",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxBrandDto"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            labels: {
                required: true,
                serializedName: "Labels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsProductBoxLabelsDto"
                        }
                    }
                }
            },
            productName: {
                serializedName: "ProductName",
                type: {
                    name: "String"
                }
            },
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsProductBoxConceptProductDto"
                        }
                    }
                }
            },
            ratingAverage: {
                required: true,
                serializedName: "RatingAverage",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxPriceDto = {
    serializedName: "StaticApplicationsProductBoxPriceDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "String"
                }
            },
            currentPrice: {
                serializedName: "CurrentPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxFormattedPriceDto = {
    serializedName: "StaticApplicationsProductBoxFormattedPriceDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxFormattedPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxPriceDto"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxProductDto = {
    serializedName: "StaticApplicationsProductBoxProductDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxProductDto",
        modelProperties: {
            backInStockAvailability: {
                serializedName: "BackInStockAvailability",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxBackInStockAvailabilityDto"
                }
            },
            concept: {
                serializedName: "Concept",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxConceptDto"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxFormattedPriceDto"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductBoxProductBoxDto = {
    serializedName: "StaticApplicationsProductBoxProductBoxDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductBoxProductBoxDto",
        modelProperties: {
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsProductBoxProductDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsProductDetailsLabelsDto = {
    serializedName: "StaticApplicationsProductDetailsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductDetailsLabelsDto",
        modelProperties: {
            ingredients: {
                serializedName: "Ingredients",
                type: {
                    name: "String"
                }
            },
            manufacturerInfo: {
                serializedName: "ManufacturerInfo",
                type: {
                    name: "String"
                }
            },
            manufacturers: {
                serializedName: "Manufacturers",
                type: {
                    name: "String"
                }
            },
            offer: {
                serializedName: "Offer",
                type: {
                    name: "String"
                }
            },
            priceValidity: {
                serializedName: "PriceValidity",
                type: {
                    name: "String"
                }
            },
            quantity: {
                serializedName: "Quantity",
                type: {
                    name: "String"
                }
            },
            questionAndAnswers: {
                serializedName: "QuestionAndAnswers",
                type: {
                    name: "String"
                }
            },
            rates: {
                serializedName: "Rates",
                type: {
                    name: "String"
                }
            },
            recentlyViewed: {
                serializedName: "RecentlyViewed",
                type: {
                    name: "String"
                }
            },
            relatedProducts: {
                serializedName: "RelatedProducts",
                type: {
                    name: "String"
                }
            },
            reviews: {
                serializedName: "Reviews",
                type: {
                    name: "String"
                }
            },
            shippingInfo: {
                serializedName: "ShippingInfo",
                type: {
                    name: "String"
                }
            },
            size: {
                serializedName: "Size",
                type: {
                    name: "String"
                }
            },
            subscribe: {
                serializedName: "Subscribe",
                type: {
                    name: "String"
                }
            },
            unitPrice: {
                serializedName: "UnitPrice",
                type: {
                    name: "String"
                }
            },
            youMightAlsoLike: {
                serializedName: "YouMightAlsoLike",
                type: {
                    name: "String"
                }
            },
            back: {
                serializedName: "Back",
                type: {
                    name: "String"
                }
            },
            backTo: {
                serializedName: "BackTo",
                type: {
                    name: "String"
                }
            },
            backToResults: {
                serializedName: "BackToResults",
                type: {
                    name: "String"
                }
            },
            about: {
                serializedName: "About",
                type: {
                    name: "String"
                }
            },
            additionalInfo: {
                serializedName: "AdditionalInfo",
                type: {
                    name: "String"
                }
            },
            addToWishlist: {
                serializedName: "AddToWishlist",
                type: {
                    name: "String"
                }
            },
            allIngredients: {
                serializedName: "AllIngredients",
                type: {
                    name: "String"
                }
            },
            basedOn: {
                serializedName: "BasedOn",
                type: {
                    name: "String"
                }
            },
            bp: {
                serializedName: "Bp",
                type: {
                    name: "String"
                }
            },
            bpDescription: {
                serializedName: "BpDescription",
                type: {
                    name: "String"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            },
            countryOfOrigin: {
                serializedName: "CountryOfOrigin",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            expiryDate: {
                serializedName: "ExpiryDate",
                type: {
                    name: "String"
                }
            },
            importerText: {
                serializedName: "ImporterText",
                type: {
                    name: "String"
                }
            },
            importerHeader: {
                serializedName: "ImporterHeader",
                type: {
                    name: "String"
                }
            },
            imageClickToZoom: {
                serializedName: "ImageClickToZoom",
                type: {
                    name: "String"
                }
            },
            howToUse: {
                serializedName: "HowToUse",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductDetailsShippingInfoDto = {
    serializedName: "StaticApplicationsProductDetailsShippingInfoDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductDetailsShippingInfoDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            content: {
                serializedName: "Content",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsProductDetailsSectionsDto = {
    serializedName: "StaticApplicationsProductDetailsSectionsDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductDetailsSectionsDto",
        modelProperties: {
            aboutDisabled: {
                required: true,
                serializedName: "AboutDisabled",
                type: {
                    name: "Boolean"
                }
            },
            shippingInfoDisabled: {
                required: true,
                serializedName: "ShippingInfoDisabled",
                type: {
                    name: "Boolean"
                }
            },
            ingredientsDisabled: {
                required: true,
                serializedName: "IngredientsDisabled",
                type: {
                    name: "Boolean"
                }
            },
            ratingAndReviewsDisabled: {
                required: true,
                serializedName: "RatingAndReviewsDisabled",
                type: {
                    name: "Boolean"
                }
            },
            howToUseDisabled: {
                required: true,
                serializedName: "HowToUseDisabled",
                type: {
                    name: "Boolean"
                }
            },
            additionalInformationDisabled: {
                required: true,
                serializedName: "AdditionalInformationDisabled",
                type: {
                    name: "Boolean"
                }
            },
            beautyEditModuleDisabled: {
                required: true,
                serializedName: "BeautyEditModuleDisabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticApplicationsProductDetailsProductDetailConfigurationDto = {
    serializedName: "StaticApplicationsProductDetailsProductDetailConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsProductDetailsProductDetailConfigurationDto",
        modelProperties: {
            maxQuantity: {
                required: true,
                serializedName: "MaxQuantity",
                type: {
                    name: "Number"
                }
            },
            isSharingEnabled: {
                required: true,
                serializedName: "IsSharingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            isMrpStatementEnabled: {
                required: true,
                serializedName: "IsMrpStatementEnabled",
                type: {
                    name: "Boolean"
                }
            },
            shippingInfo: {
                serializedName: "ShippingInfo",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductDetailsShippingInfoDto"
                }
            },
            sections: {
                serializedName: "Sections",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductDetailsSectionsDto"
                }
            },
            labels: {
                serializedName: "Labels",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductDetailsLabelsDto"
                }
            }
        }
    }
};
export var StaticApplicationsReportsGridColumnMetadataDto = {
    serializedName: "StaticApplicationsReportsGridColumnMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsReportsGridColumnMetadataDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            columnName: {
                serializedName: "ColumnName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsReportsPersonalGroupMmReportMetadataDto = {
    serializedName: "StaticApplicationsReportsPersonalGroupMmReportMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsReportsPersonalGroupMmReportMetadataDto",
        modelProperties: {
            gridColumns: {
                required: true,
                serializedName: "GridColumns",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticApplicationsReportsGridColumnMetadataDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsReportsReportsMetadataDto = {
    serializedName: "StaticApplicationsReportsReportsMetadataDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsReportsReportsMetadataDto",
        modelProperties: {
            personalGroupMmReportMetadata: {
                serializedName: "PersonalGroupMmReportMetadata",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsReportsPersonalGroupMmReportMetadataDto"
                }
            }
        }
    }
};
export var StaticApplicationsSharedLocalizationDto = {
    serializedName: "StaticApplicationsSharedLocalizationDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsSharedLocalizationDto",
        modelProperties: {
            defaultLanguage: {
                serializedName: "DefaultLanguage",
                type: {
                    name: "String"
                }
            },
            translations: {
                required: true,
                serializedName: "Translations",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Dictionary",
                            value: {
                                type: {
                                    name: "String"
                                }
                            }
                        }
                    }
                }
            },
            contents: {
                required: true,
                serializedName: "Contents",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Dictionary",
                            value: {
                                type: {
                                    name: "String"
                                }
                            }
                        }
                    }
                }
            },
            cultures: {
                required: true,
                serializedName: "Cultures",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Object"
                        }
                    }
                }
            }
        }
    }
};
export var StaticApplicationsVipCustomerBannerVipCustomerBannerDto = {
    serializedName: "StaticApplicationsVipCustomerBannerVipCustomerBannerDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsVipCustomerBannerVipCustomerBannerDto",
        modelProperties: {
            linkTitle: {
                serializedName: "LinkTitle",
                type: {
                    name: "String"
                }
            },
            linkUrl: {
                serializedName: "LinkUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticApplicationsWellnessClubBannersDto = {
    serializedName: "StaticApplicationsWellnessClubBannersDto",
    type: {
        name: "Composite",
        className: "StaticApplicationsWellnessClubBannersDto",
        modelProperties: {
            mainBannerUrl: {
                serializedName: "MainBannerUrl",
                type: {
                    name: "String"
                }
            },
            dailyWellbeingBannerUrl: {
                serializedName: "DailyWellbeingBannerUrl",
                type: {
                    name: "String"
                }
            },
            weightManagementBannerUrl: {
                serializedName: "WeightManagementBannerUrl",
                type: {
                    name: "String"
                }
            },
            sportBannerUrl: {
                serializedName: "SportBannerUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticBackInStockNotificationsConfigurationBackInStockNotificationsConfigurationDto = {
    serializedName: "StaticBackInStockNotificationsConfigurationBackInStockNotificationsConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticBackInStockNotificationsConfigurationBackInStockNotificationsConfigurationDto",
        modelProperties: {
            marketingApprovalEnabled: {
                required: true,
                serializedName: "MarketingApprovalEnabled",
                type: {
                    name: "Boolean"
                }
            },
            onlyForLoggedUsers: {
                required: true,
                serializedName: "OnlyForLoggedUsers",
                type: {
                    name: "Boolean"
                }
            },
            smsSubscriptionEnabled: {
                required: true,
                serializedName: "SmsSubscriptionEnabled",
                type: {
                    name: "Boolean"
                }
            },
            subscriptionEnabled: {
                required: true,
                serializedName: "SubscriptionEnabled",
                type: {
                    name: "Boolean"
                }
            },
            maxRequestDaysLimit: {
                required: true,
                serializedName: "MaxRequestDaysLimit",
                type: {
                    name: "Number"
                }
            },
            minimumStockLimit: {
                required: true,
                serializedName: "MinimumStockLimit",
                type: {
                    name: "Number"
                }
            },
            replacementsForAnonymousUsers: {
                required: true,
                serializedName: "ReplacementsForAnonymousUsers",
                type: {
                    name: "Boolean"
                }
            },
            showProductLikeItIsOnStock: {
                required: true,
                serializedName: "ShowProductLikeItIsOnStock",
                type: {
                    name: "Boolean"
                }
            },
            isSmsChannelDefault: {
                required: true,
                serializedName: "IsSmsChannelDefault",
                type: {
                    name: "Boolean"
                }
            },
            showMarketingApprovalWarning: {
                required: true,
                serializedName: "ShowMarketingApprovalWarning",
                type: {
                    name: "Boolean"
                }
            },
            marketingApprovalWarningText: {
                serializedName: "MarketingApprovalWarningText",
                type: {
                    name: "String"
                }
            },
            isCumulusMarket: {
                required: true,
                serializedName: "IsCumulusMarket",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticBazaarvoiceBazaarVoiceConfigurationDto = {
    serializedName: "StaticBazaarvoiceBazaarVoiceConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticBazaarvoiceBazaarVoiceConfigurationDto",
        modelProperties: {
            transactionTrackingEnabled: {
                required: true,
                serializedName: "TransactionTrackingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            dreamCatcherEnabled: {
                required: true,
                serializedName: "DreamCatcherEnabled",
                type: {
                    name: "Boolean"
                }
            },
            dreamCatcherProductCode: {
                serializedName: "DreamCatcherProductCode",
                type: {
                    name: "String"
                }
            },
            conversationsPlatformEnabled: {
                required: true,
                serializedName: "ConversationsPlatformEnabled",
                type: {
                    name: "Boolean"
                }
            },
            submissionClientScriptUrl: {
                serializedName: "SubmissionClientScriptUrl",
                type: {
                    name: "String"
                }
            },
            submissionPageId: {
                serializedName: "SubmissionPageId",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            questionsAndAnswersEnabledForSegments: {
                required: true,
                serializedName: "QuestionsAndAnswersEnabledForSegments",
                type: {
                    name: "Boolean"
                }
            },
            questionsAndAnswersEnabled: {
                required: true,
                serializedName: "QuestionsAndAnswersEnabled",
                type: {
                    name: "Boolean"
                }
            },
            ratingsAndReviewsEnabled: {
                required: true,
                serializedName: "RatingsAndReviewsEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticBonusesCommissionPlanTypeDto = {
    serializedName: "StaticBonusesCommissionPlanTypeDto",
    type: {
        name: "Composite",
        className: "StaticBonusesCommissionPlanTypeDto",
        modelProperties: {
            commissionPlanType: {
                required: true,
                serializedName: "CommissionPlanType",
                type: {
                    name: "String"
                }
            },
            commissionPlanTypeId: {
                required: true,
                serializedName: "CommissionPlanTypeId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSharedDateTimeOffsetValidityDto = {
    serializedName: "StaticSharedDateTimeOffsetValidityDto",
    type: {
        name: "Composite",
        className: "StaticSharedDateTimeOffsetValidityDto",
        modelProperties: {
            from: {
                required: true,
                serializedName: "From",
                type: {
                    name: "DateTime"
                }
            },
            to: {
                required: true,
                serializedName: "To",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticBonusesPeriodDto = {
    serializedName: "StaticBonusesPeriodDto",
    type: {
        name: "Composite",
        className: "StaticBonusesPeriodDto",
        modelProperties: {
            periodId: {
                required: true,
                serializedName: "PeriodId",
                type: {
                    name: "Number"
                }
            },
            periodCode: {
                required: true,
                serializedName: "PeriodCode",
                type: {
                    name: "Number"
                }
            },
            valid: {
                serializedName: "Valid",
                type: {
                    name: "Composite",
                    className: "StaticSharedDateTimeOffsetValidityDto"
                }
            },
            closingTime: {
                required: true,
                serializedName: "ClosingTime",
                type: {
                    name: "DateTime"
                }
            },
            offset: {
                required: true,
                serializedName: "Offset",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticBonusesCurrentPeriodDto = {
    serializedName: "StaticBonusesCurrentPeriodDto",
    type: {
        name: "Composite",
        className: "StaticBonusesCurrentPeriodDto",
        modelProperties: {
            period: {
                serializedName: "Period",
                type: {
                    name: "Composite",
                    className: "StaticBonusesPeriodDto"
                }
            },
            daysLeftInPeriod: {
                required: true,
                serializedName: "DaysLeftInPeriod",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticCampaignsRewardShopConfigurationDto = {
    serializedName: "StaticCampaignsRewardShopConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticCampaignsRewardShopConfigurationDto",
        modelProperties: {
            customerCategory: {
                serializedName: "CustomerCategory",
                type: {
                    name: "String"
                }
            },
            campaignId: {
                serializedName: "CampaignId",
                type: {
                    name: "Number"
                }
            },
            rewardsSteps: {
                required: true,
                serializedName: "RewardsSteps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCampaignsRewardShopConfigurationsDto = {
    serializedName: "StaticCampaignsRewardShopConfigurationsDto",
    type: {
        name: "Composite",
        className: "StaticCampaignsRewardShopConfigurationsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticCampaignsRewardShopConfigurationDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCataloguesCatalogueDto = {
    serializedName: "StaticCataloguesCatalogueDto",
    type: {
        name: "Composite",
        className: "StaticCataloguesCatalogueDto",
        modelProperties: {
            catalogueId: {
                required: true,
                serializedName: "CatalogueId",
                type: {
                    name: "Number"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            typeCode: {
                serializedName: "TypeCode",
                type: {
                    name: "String"
                }
            },
            priority: {
                required: true,
                serializedName: "Priority",
                type: {
                    name: "Number"
                }
            },
            valid: {
                serializedName: "Valid",
                type: {
                    name: "Composite",
                    className: "StaticSharedDateTimeOffsetValidityDto"
                }
            }
        }
    }
};
export var StaticCataloguesCataloguesDto = {
    serializedName: "StaticCataloguesCataloguesDto",
    type: {
        name: "Composite",
        className: "StaticCataloguesCataloguesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticCataloguesCatalogueDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticConceptIndexItemsConceptIndexItemsDto = {
    serializedName: "StaticConceptIndexItemsConceptIndexItemsDto",
    type: {
        name: "Composite",
        className: "StaticConceptIndexItemsConceptIndexItemsDto",
        modelProperties: {
            conceptIndexItems: {
                required: true,
                serializedName: "ConceptIndexItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OriOnlineWebApiV2ConceptIndexItemsConceptIndexItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticConceptsConceptAvailabilityDto = {
    serializedName: "StaticConceptsConceptAvailabilityDto",
    type: {
        name: "Composite",
        className: "StaticConceptsConceptAvailabilityDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            isNoLongerForSale: {
                required: true,
                serializedName: "IsNoLongerForSale",
                type: {
                    name: "Boolean"
                }
            },
            isSoldOut: {
                required: true,
                serializedName: "IsSoldOut",
                type: {
                    name: "Boolean"
                }
            },
            isOutOfStock: {
                required: true,
                serializedName: "IsOutOfStock",
                type: {
                    name: "Boolean"
                }
            },
            isNotSoldOnline: {
                required: true,
                serializedName: "IsNotSoldOnline",
                type: {
                    name: "Boolean"
                }
            },
            isComingSoon: {
                required: true,
                serializedName: "IsComingSoon",
                type: {
                    name: "Boolean"
                }
            },
            isLowStock: {
                required: true,
                serializedName: "IsLowStock",
                type: {
                    name: "Boolean"
                }
            },
            isOffer: {
                required: true,
                serializedName: "IsOffer",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            },
            isSuperDeal: {
                required: true,
                serializedName: "IsSuperDeal",
                type: {
                    name: "Boolean"
                }
            },
            isLastChance: {
                required: true,
                serializedName: "IsLastChance",
                type: {
                    name: "Boolean"
                }
            },
            isUntilStockLasts: {
                required: true,
                serializedName: "IsUntilStockLasts",
                type: {
                    name: "Boolean"
                }
            },
            isBundle: {
                required: true,
                serializedName: "IsBundle",
                type: {
                    name: "Boolean"
                }
            },
            isBackorder: {
                required: true,
                serializedName: "IsBackorder",
                type: {
                    name: "Boolean"
                }
            },
            isDeleted: {
                required: true,
                serializedName: "IsDeleted",
                type: {
                    name: "Boolean"
                }
            },
            isSalesLimited: {
                required: true,
                serializedName: "IsSalesLimited",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticConceptsConceptDto = {
    serializedName: "StaticConceptsConceptDto",
    type: {
        name: "Composite",
        className: "StaticConceptsConceptDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            activeIngredients: {
                serializedName: "ActiveIngredients",
                type: {
                    name: "String"
                }
            },
            inci: {
                serializedName: "Inci",
                type: {
                    name: "String"
                }
            },
            productStory: {
                serializedName: "ProductStory",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            howToUse: {
                serializedName: "HowToUse",
                type: {
                    name: "String"
                }
            },
            isMultiProduct: {
                required: true,
                serializedName: "IsMultiProduct",
                type: {
                    name: "Boolean"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            benefits: {
                required: true,
                serializedName: "Benefits",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            conceptInfo: {
                serializedName: "ConceptInfo",
                type: {
                    name: "String"
                }
            },
            displayName: {
                serializedName: "DisplayName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticConceptsConceptLabelsDto = {
    serializedName: "StaticConceptsConceptLabelsDto",
    type: {
        name: "Composite",
        className: "StaticConceptsConceptLabelsDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            conceptLabelsCollection: {
                required: true,
                serializedName: "ConceptLabelsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            conceptLabelDomain: {
                required: true,
                serializedName: "ConceptLabelDomain",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticConceptsPriceDto = {
    serializedName: "StaticConceptsPriceDto",
    type: {
        name: "Composite",
        className: "StaticConceptsPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                required: true,
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "Number"
                }
            },
            basicCatalogueConsultantPrice: {
                required: true,
                serializedName: "BasicCatalogueConsultantPrice",
                type: {
                    name: "Number"
                }
            },
            currentPrice: {
                required: true,
                serializedName: "CurrentPrice",
                type: {
                    name: "Number"
                }
            },
            currentConsultantPrice: {
                required: true,
                serializedName: "CurrentConsultantPrice",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticConceptsConceptPriceDto = {
    serializedName: "StaticConceptsConceptPriceDto",
    type: {
        name: "Composite",
        className: "StaticConceptsConceptPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "StaticConceptsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticConceptsConceptsLabelsDto = {
    serializedName: "StaticConceptsConceptsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticConceptsConceptsLabelsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticConceptsConceptLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticConceptsPermissionDto = {
    serializedName: "StaticConceptsPermissionDto",
    type: {
        name: "Composite",
        className: "StaticConceptsPermissionDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            canDisplay: {
                required: true,
                serializedName: "CanDisplay",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticControllersApplicationsChatBotChatBotPageMetadataDto = {
    serializedName: "StaticControllersApplicationsChatBotChatBotPageMetadataDto",
    type: {
        name: "Composite",
        className: "StaticControllersApplicationsChatBotChatBotPageMetadataDto",
        modelProperties: {
            chatBot: {
                serializedName: "ChatBot",
                type: {
                    name: "Composite",
                    className: "StaticSharedClientOptionDto"
                }
            }
        }
    }
};
export var StaticControllersProductIndexItemsProductIndexItemDto = {
    serializedName: "StaticControllersProductIndexItemsProductIndexItemDto",
    type: {
        name: "Composite",
        className: "StaticControllersProductIndexItemsProductIndexItemDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            isConsultantsOnly: {
                required: true,
                serializedName: "IsConsultantsOnly",
                type: {
                    name: "Boolean"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCountriesCountryDto = {
    serializedName: "StaticCountriesCountryDto",
    type: {
        name: "Composite",
        className: "StaticCountriesCountryDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            countryCode: {
                serializedName: "CountryCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCountriesCountriesDto = {
    serializedName: "StaticCountriesCountriesDto",
    type: {
        name: "Composite",
        className: "StaticCountriesCountriesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticCountriesCountryDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCultureBpFormatDto = {
    serializedName: "StaticCultureBpFormatDto",
    type: {
        name: "Composite",
        className: "StaticCultureBpFormatDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            removeTrailingZeros: {
                required: true,
                serializedName: "RemoveTrailingZeros",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCultureCalendarDaysDto = {
    serializedName: "StaticCultureCalendarDaysDto",
    type: {
        name: "Composite",
        className: "StaticCultureCalendarDaysDto",
        modelProperties: {
            names: {
                required: true,
                serializedName: "Names",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            shortNames: {
                required: true,
                serializedName: "ShortNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            abbreviatedNames: {
                required: true,
                serializedName: "AbbreviatedNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCultureCalendarMonthsDto = {
    serializedName: "StaticCultureCalendarMonthsDto",
    type: {
        name: "Composite",
        className: "StaticCultureCalendarMonthsDto",
        modelProperties: {
            names: {
                required: true,
                serializedName: "Names",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            abbreviatedNames: {
                required: true,
                serializedName: "AbbreviatedNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCultureCalendarPatternsDto = {
    serializedName: "StaticCultureCalendarPatternsDto",
    type: {
        name: "Composite",
        className: "StaticCultureCalendarPatternsDto",
        modelProperties: {
            fullDateTimePattern: {
                serializedName: "FullDateTimePattern",
                type: {
                    name: "String"
                }
            },
            longDatePattern: {
                serializedName: "LongDatePattern",
                type: {
                    name: "String"
                }
            },
            longTimePattern: {
                serializedName: "LongTimePattern",
                type: {
                    name: "String"
                }
            },
            monthDayPattern: {
                serializedName: "MonthDayPattern",
                type: {
                    name: "String"
                }
            },
            shortDatePattern: {
                serializedName: "ShortDatePattern",
                type: {
                    name: "String"
                }
            },
            shortDateLongTimePattern: {
                serializedName: "ShortDateLongTimePattern",
                type: {
                    name: "String"
                }
            },
            shortDateTimePattern: {
                serializedName: "ShortDateTimePattern",
                type: {
                    name: "String"
                }
            },
            shortTimePattern: {
                serializedName: "ShortTimePattern",
                type: {
                    name: "String"
                }
            },
            sortableDateTimePattern: {
                serializedName: "SortableDateTimePattern",
                type: {
                    name: "String"
                }
            },
            universalSortableDateTimePattern: {
                serializedName: "UniversalSortableDateTimePattern",
                type: {
                    name: "String"
                }
            },
            yearMonthPattern: {
                serializedName: "YearMonthPattern",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCultureCalendarFormatDto = {
    serializedName: "StaticCultureCalendarFormatDto",
    type: {
        name: "Composite",
        className: "StaticCultureCalendarFormatDto",
        modelProperties: {
            firstDayOfWeek: {
                required: true,
                serializedName: "FirstDayOfWeek",
                type: {
                    name: "Number"
                }
            },
            days: {
                serializedName: "Days",
                type: {
                    name: "Composite",
                    className: "StaticCultureCalendarDaysDto"
                }
            },
            months: {
                serializedName: "Months",
                type: {
                    name: "Composite",
                    className: "StaticCultureCalendarMonthsDto"
                }
            },
            patterns: {
                serializedName: "Patterns",
                type: {
                    name: "Composite",
                    className: "StaticCultureCalendarPatternsDto"
                }
            },
            aMDesignator: {
                serializedName: "AMDesignator",
                type: {
                    name: "String"
                }
            },
            pMDesignator: {
                serializedName: "PMDesignator",
                type: {
                    name: "String"
                }
            },
            dateSeparator: {
                serializedName: "DateSeparator",
                type: {
                    name: "String"
                }
            },
            timeSeparator: {
                serializedName: "TimeSeparator",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCultureNumberFormatDto = {
    serializedName: "StaticCultureNumberFormatDto",
    type: {
        name: "Composite",
        className: "StaticCultureNumberFormatDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            decimalSeparator: {
                serializedName: "DecimalSeparator",
                type: {
                    name: "String"
                }
            },
            groupSizes: {
                required: true,
                serializedName: "GroupSizes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            },
            groupSeparator: {
                serializedName: "GroupSeparator",
                type: {
                    name: "String"
                }
            },
            negativePattern: {
                serializedName: "NegativePattern",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCulturePointsFormatDto = {
    serializedName: "StaticCulturePointsFormatDto",
    type: {
        name: "Composite",
        className: "StaticCulturePointsFormatDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            removeTrailingZeros: {
                required: true,
                serializedName: "RemoveTrailingZeros",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCulturePercentFormatDto = {
    serializedName: "StaticCulturePercentFormatDto",
    type: {
        name: "Composite",
        className: "StaticCulturePercentFormatDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            decimalSeparator: {
                serializedName: "DecimalSeparator",
                type: {
                    name: "String"
                }
            },
            groupSizes: {
                required: true,
                serializedName: "GroupSizes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            },
            groupSeparator: {
                serializedName: "GroupSeparator",
                type: {
                    name: "String"
                }
            },
            negativePattern: {
                serializedName: "NegativePattern",
                type: {
                    name: "String"
                }
            },
            symbol: {
                serializedName: "Symbol",
                type: {
                    name: "String"
                }
            },
            positivePattern: {
                serializedName: "PositivePattern",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCultureCurrencyFormatDto = {
    serializedName: "StaticCultureCurrencyFormatDto",
    type: {
        name: "Composite",
        className: "StaticCultureCurrencyFormatDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            decimalSeparator: {
                serializedName: "DecimalSeparator",
                type: {
                    name: "String"
                }
            },
            groupSizes: {
                required: true,
                serializedName: "GroupSizes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            },
            groupSeparator: {
                serializedName: "GroupSeparator",
                type: {
                    name: "String"
                }
            },
            negativePattern: {
                serializedName: "NegativePattern",
                type: {
                    name: "String"
                }
            },
            positivePattern: {
                serializedName: "PositivePattern",
                type: {
                    name: "String"
                }
            },
            removeTrailingZeros: {
                required: true,
                serializedName: "RemoveTrailingZeros",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCultureCultureDto = {
    serializedName: "StaticCultureCultureDto",
    type: {
        name: "Composite",
        className: "StaticCultureCultureDto",
        modelProperties: {
            cultureCode: {
                serializedName: "CultureCode",
                type: {
                    name: "String"
                }
            },
            localizedName: {
                serializedName: "LocalizedName",
                type: {
                    name: "String"
                }
            },
            calendarFormat: {
                serializedName: "CalendarFormat",
                type: {
                    name: "Composite",
                    className: "StaticCultureCalendarFormatDto"
                }
            },
            bpFormat: {
                serializedName: "BpFormat",
                type: {
                    name: "Composite",
                    className: "StaticCultureBpFormatDto"
                }
            },
            numberFormat: {
                serializedName: "NumberFormat",
                type: {
                    name: "Composite",
                    className: "StaticCultureNumberFormatDto"
                }
            },
            pointsFormat: {
                serializedName: "PointsFormat",
                type: {
                    name: "Composite",
                    className: "StaticCulturePointsFormatDto"
                }
            },
            percentFormat: {
                serializedName: "PercentFormat",
                type: {
                    name: "Composite",
                    className: "StaticCulturePercentFormatDto"
                }
            },
            currencyFormat: {
                serializedName: "CurrencyFormat",
                type: {
                    name: "Composite",
                    className: "StaticCultureCurrencyFormatDto"
                }
            }
        }
    }
};
export var StaticCultureDoubleCurrencyDto = {
    serializedName: "StaticCultureDoubleCurrencyDto",
    type: {
        name: "Composite",
        className: "StaticCultureDoubleCurrencyDto",
        modelProperties: {
            decimals: {
                required: true,
                serializedName: "Decimals",
                type: {
                    name: "Number"
                }
            },
            decimalSeparator: {
                serializedName: "DecimalSeparator",
                type: {
                    name: "String"
                }
            },
            positivePattern: {
                serializedName: "PositivePattern",
                type: {
                    name: "String"
                }
            },
            negativePattern: {
                serializedName: "NegativePattern",
                type: {
                    name: "String"
                }
            },
            groupSeparator: {
                serializedName: "GroupSeparator",
                type: {
                    name: "String"
                }
            },
            removeTrailingZeros: {
                required: true,
                serializedName: "RemoveTrailingZeros",
                type: {
                    name: "Boolean"
                }
            },
            exchangeRate: {
                required: true,
                serializedName: "ExchangeRate",
                type: {
                    name: "Number"
                }
            },
            currencySymbol: {
                serializedName: "CurrencySymbol",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCultureFinancialSetDto = {
    serializedName: "StaticCultureFinancialSetDto",
    type: {
        name: "Composite",
        className: "StaticCultureFinancialSetDto",
        modelProperties: {
            financialSetId: {
                required: true,
                serializedName: "FinancialSetId",
                type: {
                    name: "Number"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            currencySymbol: {
                serializedName: "CurrencySymbol",
                type: {
                    name: "String"
                }
            },
            priceRounding: {
                required: true,
                serializedName: "PriceRounding",
                type: {
                    name: "Number"
                }
            },
            bvRounding: {
                required: true,
                serializedName: "BvRounding",
                type: {
                    name: "Number"
                }
            },
            doubleCurrency: {
                serializedName: "DoubleCurrency",
                type: {
                    name: "Composite",
                    className: "StaticCultureDoubleCurrencyDto"
                }
            }
        }
    }
};
export var StaticCultureTimeZoneDto = {
    serializedName: "StaticCultureTimeZoneDto",
    type: {
        name: "Composite",
        className: "StaticCultureTimeZoneDto",
        modelProperties: {
            tzdbId: {
                serializedName: "TzdbId",
                type: {
                    name: "String"
                }
            },
            msdbId: {
                serializedName: "MsdbId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticCultureTenantCultureDto = {
    serializedName: "StaticCultureTenantCultureDto",
    type: {
        name: "Composite",
        className: "StaticCultureTenantCultureDto",
        modelProperties: {
            defaultCultureCode: {
                serializedName: "DefaultCultureCode",
                type: {
                    name: "String"
                }
            },
            defaultFinancialSetId: {
                required: true,
                serializedName: "DefaultFinancialSetId",
                type: {
                    name: "Number"
                }
            },
            timeZone: {
                serializedName: "TimeZone",
                type: {
                    name: "Composite",
                    className: "StaticCultureTimeZoneDto"
                }
            },
            cultures: {
                required: true,
                serializedName: "Cultures",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticCultureCultureDto"
                        }
                    }
                }
            },
            financialSets: {
                required: true,
                serializedName: "FinancialSets",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticCultureFinancialSetDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCustomerConfirmationMetadataTelephoneConfirmationMetadataDto = {
    serializedName: "StaticCustomerConfirmationMetadataTelephoneConfirmationMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerConfirmationMetadataTelephoneConfirmationMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            codeLength: {
                required: true,
                serializedName: "CodeLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticCustomerConfirmationMetadataEmailConfirmationMetadataDto = {
    serializedName: "StaticCustomerConfirmationMetadataEmailConfirmationMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerConfirmationMetadataEmailConfirmationMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            codeLength: {
                required: true,
                serializedName: "CodeLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticCustomerConfirmationMetadataCustomerConfirmationMetadataDto = {
    serializedName: "StaticCustomerConfirmationMetadataCustomerConfirmationMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerConfirmationMetadataCustomerConfirmationMetadataDto",
        modelProperties: {
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "Composite",
                    className: "StaticCustomerConfirmationMetadataTelephoneConfirmationMetadataDto"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "Composite",
                    className: "StaticCustomerConfirmationMetadataEmailConfirmationMetadataDto"
                }
            }
        }
    }
};
export var StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDto = {
    serializedName: "StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDto",
        modelProperties: {
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataLoginProviderMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataLoginProviderMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataLoginProviderMetadataDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSharedMetadataValidationStringValidationDto = {
    serializedName: "StaticSharedMetadataValidationStringValidationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataValidationStringValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            regularExpression: {
                serializedName: "RegularExpression",
                type: {
                    name: "String"
                }
            },
            minLength: {
                serializedName: "MinLength",
                type: {
                    name: "Number"
                }
            },
            maxLength: {
                serializedName: "MaxLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSharedMetadataStringPropertyDto = {
    serializedName: "StaticSharedMetadataStringPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataStringPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationStringValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataRegistrationContactDetailsMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataRegistrationContactDetailsMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataRegistrationContactDetailsMetadataDto",
        modelProperties: {
            email: {
                serializedName: "Email",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            isVerificationEnabled: {
                required: true,
                serializedName: "IsVerificationEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCustomersMetadataApprovalPropertyDto = {
    serializedName: "StaticCustomersMetadataApprovalPropertyDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataApprovalPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            defaultValue: {
                required: true,
                serializedName: "DefaultValue",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCustomersMetadataCustomerApprovalSharedMetadataDto = {
    serializedName: "StaticCustomersMetadataCustomerApprovalSharedMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataCustomerApprovalSharedMetadataDto",
        modelProperties: {
            displayAsNegative: {
                required: true,
                serializedName: "DisplayAsNegative",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCustomersMetadataCustomerApprovalMetadataDto = {
    serializedName: "StaticCustomersMetadataCustomerApprovalMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataCustomerApprovalMetadataDto",
        modelProperties: {
            personalData: {
                serializedName: "PersonalData",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            contact: {
                serializedName: "Contact",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            marketingOriflame: {
                serializedName: "MarketingOriflame",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            marketingExternal: {
                serializedName: "MarketingExternal",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            publication: {
                serializedName: "Publication",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            newsletters: {
                serializedName: "Newsletters",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            uplineLeaderData: {
                serializedName: "UplineLeaderData",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            uplineLeaderBrowse: {
                serializedName: "UplineLeaderBrowse",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            orderHistory: {
                serializedName: "OrderHistory",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            marketingConsultant: {
                serializedName: "MarketingConsultant",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            blockGuaranteeOrdering: {
                serializedName: "BlockGuaranteeOrdering",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            optedOutOfSponsorSelect: {
                serializedName: "OptedOutOfSponsorSelect",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataApprovalPropertyDto"
                }
            },
            shared: {
                serializedName: "Shared",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataCustomerApprovalSharedMetadataDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataValidationDocumentValidationDto = {
    serializedName: "StaticSharedMetadataValidationDocumentValidationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataValidationDocumentValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            maxDataSize: {
                required: true,
                serializedName: "MaxDataSize",
                type: {
                    name: "Number"
                }
            },
            supportedMimeTypes: {
                serializedName: "SupportedMimeTypes",
                type: {
                    name: "String"
                }
            },
            allowMultipleDocuments: {
                required: true,
                serializedName: "AllowMultipleDocuments",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSharedMetadataValidationDateTimeValidationDto = {
    serializedName: "StaticSharedMetadataValidationDateTimeValidationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataValidationDateTimeValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            minValue: {
                serializedName: "MinValue",
                type: {
                    name: "DateTime"
                }
            },
            maxValue: {
                serializedName: "MaxValue",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticCustomersMetadataIdentityCardExpirationPropertyDto = {
    serializedName: "StaticCustomersMetadataIdentityCardExpirationPropertyDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataIdentityCardExpirationPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationDateTimeValidationDto"
                }
            },
            disabledForIdentityCardTypes: {
                required: true,
                serializedName: "DisabledForIdentityCardTypes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedMetadataValidationEnumValidationDto = {
    serializedName: "StaticSharedMetadataValidationEnumValidationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataValidationEnumValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSharedMetadataEnumPropertyDto = {
    serializedName: "StaticSharedMetadataEnumPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataEnumPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationEnumValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCustomersMetadataIdentityCardDocumentPropertyDto = {
    serializedName: "StaticCustomersMetadataIdentityCardDocumentPropertyDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataIdentityCardDocumentPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationDocumentValidationDto"
                }
            },
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            },
            expiration: {
                serializedName: "Expiration",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataIdentityCardExpirationPropertyDto"
                }
            },
            cardType: {
                serializedName: "CardType",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataEnumPropertyDto"
                }
            },
            cardNumber: {
                serializedName: "CardNumber",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataDocumentPropertyDto = {
    serializedName: "StaticSharedMetadataDocumentPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataDocumentPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationDocumentValidationDto"
                }
            },
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticUpgradeRequestMetadataTermsAndConditionsValidationDto = {
    serializedName: "StaticUpgradeRequestMetadataTermsAndConditionsValidationDto",
    type: {
        name: "Composite",
        className: "StaticUpgradeRequestMetadataTermsAndConditionsValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto = {
    serializedName: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto",
    type: {
        name: "Composite",
        className: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticUpgradeRequestMetadataTermsAndConditionsValidationDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataBooleanPropertyDto = {
    serializedName: "StaticSharedMetadataBooleanPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataBooleanPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataRegistrationLegalDetailsMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataRegistrationLegalDetailsMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataRegistrationLegalDetailsMetadataDto",
        modelProperties: {
            approvals: {
                serializedName: "Approvals",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataCustomerApprovalMetadataDto"
                }
            },
            identityCard: {
                serializedName: "IdentityCard",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataIdentityCardDocumentPropertyDto"
                }
            },
            additionalIdentityCard: {
                serializedName: "AdditionalIdentityCard",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataDocumentPropertyDto"
                }
            },
            termsAndConditions: {
                serializedName: "TermsAndConditions",
                type: {
                    name: "Composite",
                    className: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto"
                }
            },
            privacyPolicy: {
                serializedName: "PrivacyPolicy",
                type: {
                    name: "Composite",
                    className: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto"
                }
            },
            isReseller: {
                serializedName: "IsReseller",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataBooleanPropertyDto"
                }
            },
            confirmation1: {
                serializedName: "Confirmation1",
                type: {
                    name: "Composite",
                    className: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto"
                }
            },
            confirmation2: {
                serializedName: "Confirmation2",
                type: {
                    name: "Composite",
                    className: "StaticUpgradeRequestMetadataTermsAndConditionsPropertyDto"
                }
            },
            customText: {
                serializedName: "CustomText",
                type: {
                    name: "Composite",
                    className: "StaticSharedClientOptionDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataPasswordRequirementDto = {
    serializedName: "StaticSharedMetadataPasswordRequirementDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataPasswordRequirementDto",
        modelProperties: {
            isRequired: {
                required: true,
                serializedName: "IsRequired",
                type: {
                    name: "Boolean"
                }
            },
            regularExpression: {
                serializedName: "RegularExpression",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedMetadataPasswordRequirementsDto = {
    serializedName: "StaticSharedMetadataPasswordRequirementsDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataPasswordRequirementsDto",
        modelProperties: {
            letter: {
                serializedName: "Letter",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementDto"
                }
            },
            lowercaseLetter: {
                serializedName: "LowercaseLetter",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementDto"
                }
            },
            uppercaseLetter: {
                serializedName: "UppercaseLetter",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementDto"
                }
            },
            digit: {
                serializedName: "Digit",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementDto"
                }
            },
            specialCharacter: {
                serializedName: "SpecialCharacter",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataNewPasswordPropertyDto = {
    serializedName: "StaticSharedMetadataNewPasswordPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataNewPasswordPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationStringValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            isConfirmationDisplayed: {
                required: true,
                serializedName: "IsConfirmationDisplayed",
                type: {
                    name: "Boolean"
                }
            },
            requirements: {
                serializedName: "Requirements",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataPasswordRequirementsDto"
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataRegistrationMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataRegistrationMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataRegistrationMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            contactEmail: {
                serializedName: "ContactEmail",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            contactTelephone: {
                serializedName: "ContactTelephone",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            password: {
                serializedName: "Password",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataNewPasswordPropertyDto"
                }
            },
            facebookLogin: {
                serializedName: "FacebookLogin",
                type: {
                    name: "Composite",
                    className: "StaticCustomerRegistrationsMetadataLoginProviderMetadataDto"
                }
            },
            appleLogin: {
                serializedName: "AppleLogin",
                type: {
                    name: "Composite",
                    className: "StaticCustomerRegistrationsMetadataLoginProviderMetadataDto"
                }
            },
            googleLogin: {
                serializedName: "GoogleLogin",
                type: {
                    name: "Composite",
                    className: "StaticCustomerRegistrationsMetadataLoginProviderMetadataDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataDateTimePropertyDto = {
    serializedName: "StaticSharedMetadataDateTimePropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataDateTimePropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationDateTimeValidationDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataOperationsReasonDto = {
    serializedName: "StaticSharedMetadataOperationsReasonDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataOperationsReasonDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            message: {
                serializedName: "Message",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedMetadataOperationsOperationDto = {
    serializedName: "StaticSharedMetadataOperationsOperationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataOperationsOperationDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            reasons: {
                required: true,
                serializedName: "Reasons",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedMetadataOperationsReasonDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedMetadataOperationsOperationsDto = {
    serializedName: "StaticSharedMetadataOperationsOperationsDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataOperationsOperationsDto",
        modelProperties: {
            create: {
                serializedName: "Create",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataOperationsOperationDto"
                }
            },
            read: {
                serializedName: "Read",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataOperationsOperationDto"
                }
            },
            update: {
                serializedName: "Update",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataOperationsOperationDto"
                }
            },
            deleteProperty: {
                serializedName: "Delete",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataOperationsOperationDto"
                }
            }
        }
    }
};
export var StaticCustomersMetadataValidationAddressPropertyValidationDto = {
    serializedName: "StaticCustomersMetadataValidationAddressPropertyValidationDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataValidationAddressPropertyValidationDto",
        modelProperties: {
            isAddressMatchRequired: {
                required: true,
                serializedName: "IsAddressMatchRequired",
                type: {
                    name: "Boolean"
                }
            },
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            regularExpression: {
                serializedName: "RegularExpression",
                type: {
                    name: "String"
                }
            },
            minLength: {
                serializedName: "MinLength",
                type: {
                    name: "Number"
                }
            },
            maxLength: {
                serializedName: "MaxLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticCustomersMetadataCountryPropertyDto = {
    serializedName: "StaticCustomersMetadataCountryPropertyDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataCountryPropertyDto",
        modelProperties: {
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataValidationAddressPropertyValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticCustomersMetadataAddressPropertyDto = {
    serializedName: "StaticCustomersMetadataAddressPropertyDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataAddressPropertyDto",
        modelProperties: {
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataValidationAddressPropertyValidationDto"
                }
            }
        }
    }
};
export var StaticCustomersMetadataAddressSearchMetadataDto = {
    serializedName: "StaticCustomersMetadataAddressSearchMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataAddressSearchMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            allowedSearchResults: {
                required: true,
                serializedName: "AllowedSearchResults",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            maxResults: {
                required: true,
                serializedName: "MaxResults",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticCustomersMetadataRegistrationAddressMetadataDto = {
    serializedName: "StaticCustomersMetadataRegistrationAddressMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomersMetadataRegistrationAddressMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataOperationsOperationsDto"
                }
            },
            addressType: {
                serializedName: "AddressType",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataEnumPropertyDto"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataCountryPropertyDto"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            streetAddress: {
                serializedName: "StreetAddress",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            zipcode: {
                serializedName: "Zipcode",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressPropertyDto"
                }
            },
            delivery: {
                serializedName: "Delivery",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            delivery2: {
                serializedName: "Delivery2",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            delivery3: {
                serializedName: "Delivery3",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            searchOptions: {
                serializedName: "SearchOptions",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataAddressSearchMetadataDto"
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataRegistrationPersonalDetailsMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataRegistrationPersonalDetailsMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataRegistrationPersonalDetailsMetadataDto",
        modelProperties: {
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataStringPropertyDto"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataDateTimePropertyDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataEnumPropertyDto"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataRegistrationAddressMetadataDto"
                }
            }
        }
    }
};
export var StaticSharedMetadataValidationNumberValidationDto = {
    serializedName: "StaticSharedMetadataValidationNumberValidationDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataValidationNumberValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSharedMetadataNumberPropertyDto = {
    serializedName: "StaticSharedMetadataNumberPropertyDto",
    type: {
        name: "Composite",
        className: "StaticSharedMetadataNumberPropertyDto",
        modelProperties: {
            displayOrder: {
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataValidationNumberValidationDto"
                }
            }
        }
    }
};
export var StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDto = {
    serializedName: "StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDto",
    type: {
        name: "Composite",
        className: "StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDto",
        modelProperties: {
            sponsorNumber: {
                serializedName: "SponsorNumber",
                type: {
                    name: "Composite",
                    className: "StaticSharedMetadataNumberPropertyDto"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "StaticCustomersMetadataRegistrationAddressMetadataDto"
                }
            }
        }
    }
};
export var StaticDeprecatedConceptDto = {
    serializedName: "StaticDeprecatedConceptDto",
    type: {
        name: "Composite",
        className: "StaticDeprecatedConceptDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            subBrandId: {
                serializedName: "SubBrandId",
                type: {
                    name: "String"
                }
            },
            activeIngredients: {
                serializedName: "ActiveIngredients",
                type: {
                    name: "String"
                }
            },
            ingredients: {
                serializedName: "Ingredients",
                type: {
                    name: "String"
                }
            },
            productStory: {
                serializedName: "ProductStory",
                type: {
                    name: "String"
                }
            },
            categoryIds: {
                required: true,
                serializedName: "CategoryIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            productDescription: {
                serializedName: "ProductDescription",
                type: {
                    name: "String"
                }
            },
            howToUse: {
                serializedName: "HowToUse",
                type: {
                    name: "String"
                }
            },
            isMultiProduct: {
                required: true,
                serializedName: "IsMultiProduct",
                type: {
                    name: "Boolean"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productName: {
                serializedName: "ProductName",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            info: {
                serializedName: "Info",
                type: {
                    name: "String"
                }
            },
            thumbnailImageUrl: {
                serializedName: "ThumbnailImageUrl",
                type: {
                    name: "String"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            ratingAverage: {
                required: true,
                serializedName: "RatingAverage",
                type: {
                    name: "Number"
                }
            },
            ratingCount: {
                required: true,
                serializedName: "RatingCount",
                type: {
                    name: "Number"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            about: {
                serializedName: "About",
                type: {
                    name: "String"
                }
            },
            benefits: {
                required: true,
                serializedName: "Benefits",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDeprecatedTagDto = {
    serializedName: "StaticDeprecatedTagDto",
    type: {
        name: "Composite",
        className: "StaticDeprecatedTagDto",
        modelProperties: {
            value: {
                serializedName: "Value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticDeprecatedTagGroupDto = {
    serializedName: "StaticDeprecatedTagGroupDto",
    type: {
        name: "Composite",
        className: "StaticDeprecatedTagGroupDto",
        modelProperties: {
            groupName: {
                serializedName: "GroupName",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            translation: {
                serializedName: "Translation",
                type: {
                    name: "String"
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDeprecatedTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDeprecatedProductDto = {
    serializedName: "StaticDeprecatedProductDto",
    type: {
        name: "Composite",
        className: "StaticDeprecatedProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productType: {
                required: true,
                serializedName: "ProductType",
                type: {
                    name: "String"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            },
            colorHexCode: {
                serializedName: "ColorHexCode",
                type: {
                    name: "String"
                }
            },
            colorImageUrl: {
                serializedName: "ColorImageUrl",
                type: {
                    name: "String"
                }
            },
            volume: {
                serializedName: "Volume",
                type: {
                    name: "Number"
                }
            },
            volumeUnit: {
                serializedName: "VolumeUnit",
                type: {
                    name: "String"
                }
            },
            thumbnailUrl: {
                serializedName: "ThumbnailUrl",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            alternativeImageUrls: {
                required: true,
                serializedName: "AlternativeImageUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDeprecatedTagGroupDto"
                        }
                    }
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            introDate: {
                serializedName: "IntroDate",
                type: {
                    name: "DateTime"
                }
            },
            discoDate: {
                serializedName: "DiscoDate",
                type: {
                    name: "DateTime"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            videoUrl: {
                serializedName: "VideoUrl",
                type: {
                    name: "String"
                }
            },
            manufacturerIds: {
                required: true,
                serializedName: "ManufacturerIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            sampleCode: {
                serializedName: "SampleCode",
                type: {
                    name: "String"
                }
            },
            dimension: {
                serializedName: "Dimension",
                type: {
                    name: "String"
                }
            },
            parentProductCodes: {
                required: true,
                serializedName: "ParentProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsBannerDto = {
    serializedName: "StaticDigitalPromotionsBannerDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsBannerDto",
        modelProperties: {
            bannerId: {
                serializedName: "BannerId",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            mobileFontColor: {
                serializedName: "MobileFontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticDigitalPromotionsBestOffersBannersDto = {
    serializedName: "StaticDigitalPromotionsBestOffersBannersDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsBestOffersBannersDto",
        modelProperties: {
            bestOffersBanners: {
                required: true,
                serializedName: "BestOffersBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCampaignBannerDto = {
    serializedName: "StaticDigitalPromotionsCampaignBannerDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCampaignBannerDto",
        modelProperties: {
            bannerId: {
                serializedName: "BannerId",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            mobileFontColor: {
                serializedName: "MobileFontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            },
            backgroundColor: {
                serializedName: "BackgroundColor",
                type: {
                    name: "String"
                }
            },
            shortText: {
                serializedName: "ShortText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCampaignBannersDto = {
    serializedName: "StaticDigitalPromotionsCampaignBannersDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCampaignBannersDto",
        modelProperties: {
            campaignBanners: {
                required: true,
                serializedName: "CampaignBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsCampaignBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCategoryBannerDto = {
    serializedName: "StaticDigitalPromotionsCategoryBannerDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCategoryBannerDto",
        modelProperties: {
            bannerId: {
                serializedName: "BannerId",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            mobileFontColor: {
                serializedName: "MobileFontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            },
            shortText: {
                serializedName: "ShortText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCategoryBannersDto = {
    serializedName: "StaticDigitalPromotionsCategoryBannersDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCategoryBannersDto",
        modelProperties: {
            categoryBanners: {
                required: true,
                serializedName: "CategoryBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsCategoryBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCurrentPromotionDto = {
    serializedName: "StaticDigitalPromotionsCurrentPromotionDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCurrentPromotionDto",
        modelProperties: {
            promotionType: {
                required: true,
                serializedName: "PromotionType",
                type: {
                    name: "String"
                }
            },
            channel: {
                required: true,
                serializedName: "Channel",
                type: {
                    name: "String"
                }
            },
            bannerIds: {
                required: true,
                serializedName: "BannerIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsCurrentPromotionsDto = {
    serializedName: "StaticDigitalPromotionsCurrentPromotionsDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsCurrentPromotionsDto",
        modelProperties: {
            currentPromotions: {
                required: true,
                serializedName: "CurrentPromotions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsCurrentPromotionDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsHeroBannerDto = {
    serializedName: "StaticDigitalPromotionsHeroBannerDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsHeroBannerDto",
        modelProperties: {
            bannerId: {
                serializedName: "BannerId",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            },
            mobileFontColor: {
                serializedName: "MobileFontColor",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            },
            priority: {
                serializedName: "Priority",
                type: {
                    name: "String"
                }
            },
            videoUrl: {
                serializedName: "VideoUrl",
                type: {
                    name: "String"
                }
            },
            smallImageUrl: {
                serializedName: "SmallImageUrl",
                type: {
                    name: "String"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticDigitalPromotionsHeroBannersDto = {
    serializedName: "StaticDigitalPromotionsHeroBannersDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsHeroBannersDto",
        modelProperties: {
            heroBanners: {
                required: true,
                serializedName: "HeroBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsHeroBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDigitalPromotionsWhatsNewBannersDto = {
    serializedName: "StaticDigitalPromotionsWhatsNewBannersDto",
    type: {
        name: "Composite",
        className: "StaticDigitalPromotionsWhatsNewBannersDto",
        modelProperties: {
            whatsNewBanners: {
                required: true,
                serializedName: "WhatsNewBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDigitalPromotionsBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticDocumentsDocumentTypeDto = {
    serializedName: "StaticDocumentsDocumentTypeDto",
    type: {
        name: "Composite",
        className: "StaticDocumentsDocumentTypeDto",
        modelProperties: {
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            maxDataSize: {
                required: true,
                serializedName: "MaxDataSize",
                type: {
                    name: "Number"
                }
            },
            supportedMimeTypes: {
                serializedName: "SupportedMimeTypes",
                type: {
                    name: "String"
                }
            },
            documentTag: {
                required: true,
                serializedName: "DocumentTag",
                type: {
                    name: "String"
                }
            },
            documentCategory: {
                required: true,
                serializedName: "DocumentCategory",
                type: {
                    name: "String"
                }
            },
            allowMultipleDocuments: {
                required: true,
                serializedName: "AllowMultipleDocuments",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticDynamicLinksDynamicLinkDto = {
    serializedName: "StaticDynamicLinksDynamicLinkDto",
    type: {
        name: "Composite",
        className: "StaticDynamicLinksDynamicLinkDto",
        modelProperties: {
            link: {
                serializedName: "Link",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticECatalogueSearchSearchSpreadDto = {
    serializedName: "StaticECatalogueSearchSearchSpreadDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueSearchSearchSpreadDto",
        modelProperties: {
            pageLeft: {
                required: true,
                serializedName: "PageLeft",
                type: {
                    name: "Number"
                }
            },
            pageRight: {
                required: true,
                serializedName: "PageRight",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticECatalogueSearchSearchResultDataDto = {
    serializedName: "StaticECatalogueSearchSearchResultDataDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueSearchSearchResultDataDto",
        modelProperties: {
            page: {
                required: true,
                serializedName: "Page",
                type: {
                    name: "Number"
                }
            },
            spread: {
                serializedName: "Spread",
                type: {
                    name: "Composite",
                    className: "StaticECatalogueSearchSearchSpreadDto"
                }
            }
        }
    }
};
export var StaticECatalogueSearchSearchResultDto = {
    serializedName: "StaticECatalogueSearchSearchResultDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueSearchSearchResultDto",
        modelProperties: {
            hasMore: {
                required: true,
                serializedName: "HasMore",
                type: {
                    name: "Boolean"
                }
            },
            data: {
                required: true,
                serializedName: "Data",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticECatalogueSearchSearchResultDataDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticECatalogueSearchSearchResultRootDto = {
    serializedName: "StaticECatalogueSearchSearchResultRootDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueSearchSearchResultRootDto",
        modelProperties: {
            paperResults: {
                serializedName: "PaperResults",
                type: {
                    name: "Composite",
                    className: "StaticECatalogueSearchSearchResultDto"
                }
            },
            pageResults: {
                serializedName: "PageResults",
                type: {
                    name: "Composite",
                    className: "StaticECatalogueSearchSearchResultDto"
                }
            },
            resultCount: {
                required: true,
                serializedName: "ResultCount",
                type: {
                    name: "Number"
                }
            },
            normalizedSearchTerm: {
                serializedName: "NormalizedSearchTerm",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticECatalogueStructureImageDto = {
    serializedName: "StaticECatalogueStructureImageDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueStructureImageDto",
        modelProperties: {
            fileSize: {
                required: true,
                serializedName: "FileSize",
                type: {
                    name: "Number"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticECatalogueStructurePageDto = {
    serializedName: "StaticECatalogueStructurePageDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueStructurePageDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            number: {
                required: true,
                serializedName: "Number",
                type: {
                    name: "Number"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            isPartOfIndex: {
                required: true,
                serializedName: "IsPartOfIndex",
                type: {
                    name: "Boolean"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticECatalogueStructureImageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticECatalogueStructureECatalogueStructureDto = {
    serializedName: "StaticECatalogueStructureECatalogueStructureDto",
    type: {
        name: "Composite",
        className: "StaticECatalogueStructureECatalogueStructureDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            pages: {
                required: true,
                serializedName: "Pages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticECatalogueStructurePageDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticEditorialArticlesEditorialArticleImageDto = {
    serializedName: "StaticEditorialArticlesEditorialArticleImageDto",
    type: {
        name: "Composite",
        className: "StaticEditorialArticlesEditorialArticleImageDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            alt: {
                serializedName: "Alt",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticEditorialArticlesEditorialArticleDto = {
    serializedName: "StaticEditorialArticlesEditorialArticleDto",
    type: {
        name: "Composite",
        className: "StaticEditorialArticlesEditorialArticleDto",
        modelProperties: {
            articleType: {
                required: true,
                serializedName: "ArticleType",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            categoryTitle: {
                serializedName: "CategoryTitle",
                type: {
                    name: "String"
                }
            },
            introText: {
                serializedName: "IntroText",
                type: {
                    name: "String"
                }
            },
            isVideoArticle: {
                required: true,
                serializedName: "IsVideoArticle",
                type: {
                    name: "Boolean"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "Composite",
                    className: "StaticEditorialArticlesEditorialArticleImageDto"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            published: {
                required: true,
                serializedName: "Published",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticEditorialArticlesEditorialArticlesDto = {
    serializedName: "StaticEditorialArticlesEditorialArticlesDto",
    type: {
        name: "Composite",
        className: "StaticEditorialArticlesEditorialArticlesDto",
        modelProperties: {
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            },
            articlesCollection: {
                required: true,
                serializedName: "ArticlesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticEditorialArticlesEditorialArticleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticIngredientLibraryIngredientDto = {
    serializedName: "StaticIngredientLibraryIngredientDto",
    type: {
        name: "Composite",
        className: "StaticIngredientLibraryIngredientDto",
        modelProperties: {
            itemName: {
                serializedName: "ItemName",
                type: {
                    name: "String"
                }
            },
            shortName: {
                serializedName: "ShortName",
                type: {
                    name: "String"
                }
            },
            latinName: {
                serializedName: "LatinName",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            keyBenefit1: {
                serializedName: "KeyBenefit1",
                type: {
                    name: "String"
                }
            },
            keyBenefit2: {
                serializedName: "KeyBenefit2",
                type: {
                    name: "String"
                }
            },
            keyBenefit3: {
                serializedName: "KeyBenefit3",
                type: {
                    name: "String"
                }
            },
            keyBenefits: {
                required: true,
                serializedName: "KeyBenefits",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            didYouKnow: {
                serializedName: "DidYouKnow",
                type: {
                    name: "String"
                }
            },
            benefitSummary: {
                serializedName: "BenefitSummary",
                type: {
                    name: "String"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            relatedArticlesIds: {
                required: true,
                serializedName: "RelatedArticlesIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticIngredientLibraryIngredientsDto = {
    serializedName: "StaticIngredientLibraryIngredientsDto",
    type: {
        name: "Composite",
        className: "StaticIngredientLibraryIngredientsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticIngredientLibraryIngredientDto"
                        }
                    }
                }
            },
            skip: {
                serializedName: "Skip",
                type: {
                    name: "Number"
                }
            },
            top: {
                serializedName: "Top",
                type: {
                    name: "Number"
                }
            },
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticIngredientsInspirationsIngredientsInspirationsDto = {
    serializedName: "StaticIngredientsInspirationsIngredientsInspirationsDto",
    type: {
        name: "Composite",
        className: "StaticIngredientsInspirationsIngredientsInspirationsDto",
        modelProperties: {
            inspirationTexts: {
                required: true,
                serializedName: "InspirationTexts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticInviteFriendConfigurationConfigurationDto = {
    serializedName: "StaticInviteFriendConfigurationConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticInviteFriendConfigurationConfigurationDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            isDynamicLinkEnabled: {
                required: true,
                serializedName: "IsDynamicLinkEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticJoiningFeeDialogJoiningFeeDialogHtmlDto = {
    serializedName: "StaticJoiningFeeDialogJoiningFeeDialogHtmlDto",
    type: {
        name: "Composite",
        className: "StaticJoiningFeeDialogJoiningFeeDialogHtmlDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            imageText: {
                serializedName: "ImageText",
                type: {
                    name: "String"
                }
            },
            productLabel: {
                serializedName: "ProductLabel",
                type: {
                    name: "String"
                }
            },
            productPrice: {
                serializedName: "ProductPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLanguagesLanguage = {
    serializedName: "StaticLanguagesLanguage",
    type: {
        name: "Composite",
        className: "StaticLanguagesLanguage",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLanguagesLanguagesDto = {
    serializedName: "StaticLanguagesLanguagesDto",
    type: {
        name: "Composite",
        className: "StaticLanguagesLanguagesDto",
        modelProperties: {
            languages: {
                required: true,
                serializedName: "Languages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLanguagesLanguage"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookBannerBackgroundColorDto = {
    serializedName: "StaticLookbookBannerBackgroundColorDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerBackgroundColorDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLookbookBannerBackgroundImageDto = {
    serializedName: "StaticLookbookBannerBackgroundImageDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerBackgroundImageDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLookbookBannerBackgroundVideoDto = {
    serializedName: "StaticLookbookBannerBackgroundVideoDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerBackgroundVideoDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            autoplayOnScroll: {
                required: true,
                serializedName: "AutoplayOnScroll",
                type: {
                    name: "Boolean"
                }
            },
            playInLoop: {
                required: true,
                serializedName: "PlayInLoop",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticLookbookBannerTextWrapperDto = {
    serializedName: "StaticLookbookBannerTextWrapperDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerTextWrapperDto",
        modelProperties: {
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLookbookBannerLookbookBannerContentDto = {
    serializedName: "StaticLookbookBannerLookbookBannerContentDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerLookbookBannerContentDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            button: {
                serializedName: "Button",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            textCollection: {
                required: true,
                serializedName: "TextCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookBannerTextWrapperDto"
                        }
                    }
                }
            },
            horizontalAlign: {
                required: true,
                serializedName: "HorizontalAlign",
                type: {
                    name: "String"
                }
            },
            verticalAlign: {
                required: true,
                serializedName: "VerticalAlign",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLookbookBannerLookbookBannerModuleDto = {
    serializedName: "StaticLookbookBannerLookbookBannerModuleDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerLookbookBannerModuleDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "StaticSharedLinkDto"
                }
            },
            backgroundType: {
                required: true,
                serializedName: "BackgroundType",
                type: {
                    name: "String"
                }
            },
            backgroundVideo: {
                serializedName: "BackgroundVideo",
                type: {
                    name: "Composite",
                    className: "StaticLookbookBannerBackgroundVideoDto"
                }
            },
            backgroundImage: {
                serializedName: "BackgroundImage",
                type: {
                    name: "Composite",
                    className: "StaticLookbookBannerBackgroundImageDto"
                }
            },
            backgroundColor: {
                serializedName: "BackgroundColor",
                type: {
                    name: "Composite",
                    className: "StaticLookbookBannerBackgroundColorDto"
                }
            },
            content: {
                serializedName: "Content",
                type: {
                    name: "Composite",
                    className: "StaticLookbookBannerLookbookBannerContentDto"
                }
            }
        }
    }
};
export var StaticLookbookBannerLookbookBannerDto = {
    serializedName: "StaticLookbookBannerLookbookBannerDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerLookbookBannerDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            layout: {
                required: true,
                serializedName: "Layout",
                type: {
                    name: "String"
                }
            },
            modules: {
                required: true,
                serializedName: "Modules",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookBannerLookbookBannerModuleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookBannerLookbookBannersDto = {
    serializedName: "StaticLookbookBannerLookbookBannersDto",
    type: {
        name: "Composite",
        className: "StaticLookbookBannerLookbookBannersDto",
        modelProperties: {
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            },
            lookbookBanners: {
                required: true,
                serializedName: "LookbookBanners",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookBannerLookbookBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookEditorialArticlesCarouselDto = {
    serializedName: "StaticLookbookEditorialArticlesCarouselDto",
    type: {
        name: "Composite",
        className: "StaticLookbookEditorialArticlesCarouselDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            showEditorialArticlesForRelatedProducts: {
                required: true,
                serializedName: "ShowEditorialArticlesForRelatedProducts",
                type: {
                    name: "Boolean"
                }
            },
            editorialArticleIds: {
                required: true,
                serializedName: "EditorialArticleIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookEditorialArticlesCarouselsDto = {
    serializedName: "StaticLookbookEditorialArticlesCarouselsDto",
    type: {
        name: "Composite",
        className: "StaticLookbookEditorialArticlesCarouselsDto",
        modelProperties: {
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            },
            editorialArticlesCarousels: {
                required: true,
                serializedName: "EditorialArticlesCarousels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookEditorialArticlesCarouselDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookModuleDto = {
    serializedName: "StaticLookbookModuleDto",
    type: {
        name: "Composite",
        className: "StaticLookbookModuleDto",
        modelProperties: {
            moduleId: {
                serializedName: "ModuleId",
                type: {
                    name: "String"
                }
            },
            moduleType: {
                required: true,
                serializedName: "ModuleType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticLookbookLookbookDto = {
    serializedName: "StaticLookbookLookbookDto",
    type: {
        name: "Composite",
        className: "StaticLookbookLookbookDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            categories: {
                required: true,
                serializedName: "Categories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedLinkDto"
                        }
                    }
                }
            },
            publishedDate: {
                required: true,
                serializedName: "PublishedDate",
                type: {
                    name: "DateTime"
                }
            },
            editorName: {
                serializedName: "EditorName",
                type: {
                    name: "String"
                }
            },
            modules: {
                required: true,
                serializedName: "Modules",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookModuleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookLookbookProductBoxCarouselDto = {
    serializedName: "StaticLookbookLookbookProductBoxCarouselDto",
    type: {
        name: "Composite",
        className: "StaticLookbookLookbookProductBoxCarouselDto",
        modelProperties: {
            usePopularProductForCategories: {
                required: true,
                serializedName: "UsePopularProductForCategories",
                type: {
                    name: "Boolean"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookLookbookProductBoxCarouselsDto = {
    serializedName: "StaticLookbookLookbookProductBoxCarouselsDto",
    type: {
        name: "Composite",
        className: "StaticLookbookLookbookProductBoxCarouselsDto",
        modelProperties: {
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            },
            productBoxCarousels: {
                required: true,
                serializedName: "ProductBoxCarousels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookLookbookProductBoxCarouselDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticLookbookLookbooksDto = {
    serializedName: "StaticLookbookLookbooksDto",
    type: {
        name: "Composite",
        className: "StaticLookbookLookbooksDto",
        modelProperties: {
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            },
            lookbooks: {
                required: true,
                serializedName: "Lookbooks",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticLookbookLookbookDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppTypeDto = {
    serializedName: "StaticMobileAppsMobileAppTypeDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppTypeDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppDto = {
    serializedName: "StaticMobileAppsMobileAppDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            titleImage: {
                serializedName: "TitleImage",
                type: {
                    name: "String"
                }
            },
            images: {
                required: true,
                serializedName: "Images",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            mobileAppType: {
                serializedName: "MobileAppType",
                type: {
                    name: "Composite",
                    className: "StaticMobileAppsMobileAppTypeDto"
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppLinksDto = {
    serializedName: "StaticMobileAppsMobileAppLinksDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppLinksDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            googlePlayStoreLink: {
                serializedName: "GooglePlayStoreLink",
                type: {
                    name: "String"
                }
            },
            appleStoreLink: {
                serializedName: "AppleStoreLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppsDownloadPageHeaderDto = {
    serializedName: "StaticMobileAppsMobileAppsDownloadPageHeaderDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppsDownloadPageHeaderDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            googlePlayImage: {
                serializedName: "GooglePlayImage",
                type: {
                    name: "String"
                }
            },
            appleStoreImage: {
                serializedName: "AppleStoreImage",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppsDto = {
    serializedName: "StaticMobileAppsMobileAppsDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppsDto",
        modelProperties: {
            mobileApps: {
                required: true,
                serializedName: "MobileApps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMobileAppsMobileAppDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMobileAppsMobileAppsLinksDto = {
    serializedName: "StaticMobileAppsMobileAppsLinksDto",
    type: {
        name: "Composite",
        className: "StaticMobileAppsMobileAppsLinksDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMobileAppsMobileAppLinksDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ConceptsBrandInfoDto = {
    serializedName: "StaticMV7ConceptsBrandInfoDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsBrandInfoDto",
        modelProperties: {
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ConceptsProductInfoDto = {
    serializedName: "StaticMV7ConceptsProductInfoDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsProductInfoDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ConceptsConceptDto = {
    serializedName: "StaticMV7ConceptsConceptDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsConceptDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            productDescription: {
                serializedName: "ProductDescription",
                type: {
                    name: "String"
                }
            },
            ratingCount: {
                required: true,
                serializedName: "RatingCount",
                type: {
                    name: "Number"
                }
            },
            ratingAverage: {
                required: true,
                serializedName: "RatingAverage",
                type: {
                    name: "Number"
                }
            },
            brand: {
                serializedName: "Brand",
                type: {
                    name: "Composite",
                    className: "StaticMV7ConceptsBrandInfoDto"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            productName: {
                serializedName: "ProductName",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            howToUse: {
                serializedName: "HowToUse",
                type: {
                    name: "String"
                }
            },
            ingredients: {
                serializedName: "Ingredients",
                type: {
                    name: "String"
                }
            },
            benefits: {
                required: true,
                serializedName: "Benefits",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            productStory: {
                serializedName: "ProductStory",
                type: {
                    name: "String"
                }
            },
            info: {
                serializedName: "Info",
                type: {
                    name: "String"
                }
            },
            isMultiProduct: {
                serializedName: "IsMultiProduct",
                type: {
                    name: "String"
                }
            },
            primaryProduct: {
                serializedName: "PrimaryProduct",
                type: {
                    name: "Composite",
                    className: "StaticMV7ConceptsProductInfoDto"
                }
            },
            hashCode: {
                serializedName: "HashCode",
                type: {
                    name: "String"
                }
            },
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ConceptsProductInfoDto"
                        }
                    }
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticMV7ConceptsConceptsDto = {
    serializedName: "StaticMV7ConceptsConceptsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsConceptsDto",
        modelProperties: {
            concepts: {
                required: true,
                serializedName: "Concepts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ConceptsConceptDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ConceptsHashCodesConceptsHashCodeDto = {
    serializedName: "StaticMV7ConceptsHashCodesConceptsHashCodeDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsHashCodesConceptsHashCodeDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            hashCode: {
                serializedName: "HashCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ConceptsHashCodesConceptsHashCodesDto = {
    serializedName: "StaticMV7ConceptsHashCodesConceptsHashCodesDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsHashCodesConceptsHashCodesDto",
        modelProperties: {
            concepts: {
                required: true,
                serializedName: "Concepts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ConceptsHashCodesConceptsHashCodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ConceptsLabelsConceptLabelsDto = {
    serializedName: "StaticMV7ConceptsLabelsConceptLabelsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsLabelsConceptLabelsDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            productLabelDomain: {
                serializedName: "ProductLabelDomain",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ConceptsLabelsConceptsLabelsDto = {
    serializedName: "StaticMV7ConceptsLabelsConceptsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsLabelsConceptsLabelsDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            labels: {
                required: true,
                serializedName: "Labels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ConceptsLabelsConceptLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ConceptsLabelsConceptsLabelsResponseDto = {
    serializedName: "StaticMV7ConceptsLabelsConceptsLabelsResponseDto",
    type: {
        name: "Composite",
        className: "StaticMV7ConceptsLabelsConceptsLabelsResponseDto",
        modelProperties: {
            concepts: {
                required: true,
                serializedName: "Concepts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ConceptsLabelsConceptsLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7HomepageIHomepageModuleDto = {
    serializedName: "StaticMV7HomepageIHomepageModuleDto",
    type: {
        name: "Composite",
        className: "StaticMV7HomepageIHomepageModuleDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            type: {
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7HomepageHomepageDto = {
    serializedName: "StaticMV7HomepageHomepageDto",
    type: {
        name: "Composite",
        className: "StaticMV7HomepageHomepageDto",
        modelProperties: {
            tenant: {
                serializedName: "Tenant",
                type: {
                    name: "String"
                }
            },
            language: {
                serializedName: "Language",
                type: {
                    name: "String"
                }
            },
            modules: {
                required: true,
                serializedName: "Modules",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7HomepageIHomepageModuleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7HomepageUserSegmentTypeDto = {
    serializedName: "StaticMV7HomepageUserSegmentTypeDto",
    type: {
        name: "Composite",
        className: "StaticMV7HomepageUserSegmentTypeDto",
        modelProperties: {
            userType: {
                serializedName: "UserType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7NavigationNavigationTreeNodeDto = {
    serializedName: "StaticMV7NavigationNavigationTreeNodeDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationNavigationTreeNodeDto",
        modelProperties: {
            id: {
                readOnly: true,
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                readOnly: true,
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                readOnly: true,
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            fullName: {
                readOnly: true,
                serializedName: "FullName",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                readOnly: true,
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                serializedName: "TaxonomyId",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                readOnly: true,
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            mobileAppImageUrl: {
                serializedName: "MobileAppImageUrl",
                type: {
                    name: "String"
                }
            },
            logoUrl: {
                readOnly: true,
                serializedName: "LogoUrl",
                type: {
                    name: "String"
                }
            },
            conceptsCount: {
                required: true,
                serializedName: "ConceptsCount",
                type: {
                    name: "Number"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7NavigationNavigationTreeNodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7NavigationBrandNavigationTreeDto = {
    serializedName: "StaticMV7NavigationBrandNavigationTreeDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationBrandNavigationTreeDto",
        modelProperties: {
            brands: {
                required: true,
                serializedName: "Brands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7NavigationNavigationTreeNodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7NavigationCategoryNavigationTreeDto = {
    serializedName: "StaticMV7NavigationCategoryNavigationTreeDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationCategoryNavigationTreeDto",
        modelProperties: {
            categories: {
                required: true,
                serializedName: "Categories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7NavigationNavigationTreeNodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7NavigationFacetValueDto = {
    serializedName: "StaticMV7NavigationFacetValueDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationFacetValueDto",
        modelProperties: {
            key: {
                serializedName: "Key",
                type: {
                    name: "String"
                }
            },
            count: {
                required: true,
                serializedName: "Count",
                type: {
                    name: "Number"
                }
            },
            active: {
                required: true,
                serializedName: "Active",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticMV7NavigationFacetDto = {
    serializedName: "StaticMV7NavigationFacetDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationFacetDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7NavigationFacetValueDto"
                        }
                    }
                }
            },
            active: {
                required: true,
                serializedName: "Active",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticMV7NavigationConceptsDto = {
    serializedName: "StaticMV7NavigationConceptsDto",
    type: {
        name: "Composite",
        className: "StaticMV7NavigationConceptsDto",
        modelProperties: {
            responseResultsCount: {
                required: true,
                serializedName: "ResponseResultsCount",
                type: {
                    name: "Number"
                }
            },
            totalResultsCount: {
                required: true,
                serializedName: "TotalResultsCount",
                type: {
                    name: "Number"
                }
            },
            conceptCodes: {
                required: true,
                serializedName: "ConceptCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            facets: {
                required: true,
                serializedName: "Facets",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7NavigationFacetDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductListingsProductListingPromoItemDto = {
    serializedName: "StaticMV7ProductListingsProductListingPromoItemDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductListingsProductListingPromoItemDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ProductListingsProductListingPromosDto = {
    serializedName: "StaticMV7ProductListingsProductListingPromosDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductListingsProductListingPromosDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            promos: {
                required: true,
                serializedName: "Promos",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductListingsProductListingPromoItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsConceptInfoDto = {
    serializedName: "StaticMV7ProductsConceptInfoDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsConceptInfoDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ProductsHashCodesProductHashCodeDto = {
    serializedName: "StaticMV7ProductsHashCodesProductHashCodeDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsHashCodesProductHashCodeDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticMV7ProductsHashCodesProductsHashCodesDto = {
    serializedName: "StaticMV7ProductsHashCodesProductsHashCodesDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsHashCodesProductsHashCodesDto",
        modelProperties: {
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsHashCodesProductHashCodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsLabelsProductLabelsDto = {
    serializedName: "StaticMV7ProductsLabelsProductLabelsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsLabelsProductLabelsDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            productLabelDomain: {
                serializedName: "ProductLabelDomain",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ProductsLabelsProductsLabelsDto = {
    serializedName: "StaticMV7ProductsLabelsProductsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsLabelsProductsLabelsDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            labels: {
                required: true,
                serializedName: "Labels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsLabelsProductLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsLabelsProductsLabelsResponseDto = {
    serializedName: "StaticMV7ProductsLabelsProductsLabelsResponseDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsLabelsProductsLabelsResponseDto",
        modelProperties: {
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsLabelsProductsLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsPricesPriceDto = {
    serializedName: "StaticMV7ProductsPricesPriceDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsPricesPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "String"
                }
            },
            basicCatalogueConsultantPrice: {
                serializedName: "BasicCatalogueConsultantPrice",
                type: {
                    name: "String"
                }
            },
            currentPrice: {
                serializedName: "CurrentPrice",
                type: {
                    name: "String"
                }
            },
            currentConsultantPrice: {
                serializedName: "CurrentConsultantPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ProductsPricesProductPriceDto = {
    serializedName: "StaticMV7ProductsPricesProductPriceDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsPricesProductPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsPricesPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticMV7ProductsPricesProductsPricesDto = {
    serializedName: "StaticMV7ProductsPricesProductsPricesDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsPricesProductsPricesDto",
        modelProperties: {
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsPricesProductPriceDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsProductPermissionDto = {
    serializedName: "StaticMV7ProductsProductPermissionDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsProductPermissionDto",
        modelProperties: {
            canDisplay: {
                required: true,
                serializedName: "CanDisplay",
                type: {
                    name: "Boolean"
                }
            },
            canBuy: {
                required: true,
                serializedName: "CanBuy",
                type: {
                    name: "Boolean"
                }
            },
            canSell: {
                required: true,
                serializedName: "CanSell",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticMV7ProductsProductInfoDto = {
    serializedName: "StaticMV7ProductsProductInfoDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsProductInfoDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticMV7ProductsProductReplacementsDto = {
    serializedName: "StaticMV7ProductsProductReplacementsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsProductReplacementsDto",
        modelProperties: {
            product: {
                serializedName: "Product",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsProductInfoDto"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticMV7ProductsProductDto = {
    serializedName: "StaticMV7ProductsProductDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productType: {
                serializedName: "ProductType",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            },
            colorHexCode: {
                serializedName: "ColorHexCode",
                type: {
                    name: "String"
                }
            },
            colorImageUrl: {
                serializedName: "ColorImageUrl",
                type: {
                    name: "String"
                }
            },
            shadeName: {
                serializedName: "ShadeName",
                type: {
                    name: "String"
                }
            },
            dimensionsText: {
                serializedName: "DimensionsText",
                type: {
                    name: "String"
                }
            },
            volume: {
                required: true,
                serializedName: "Volume",
                type: {
                    name: "Number"
                }
            },
            volumeUnit: {
                serializedName: "VolumeUnit",
                type: {
                    name: "String"
                }
            },
            volumeUnitText: {
                serializedName: "VolumeUnitText",
                type: {
                    name: "String"
                }
            },
            thumbnailUrl: {
                serializedName: "ThumbnailUrl",
                type: {
                    name: "String"
                }
            },
            alternativeImageUrl: {
                serializedName: "AlternativeImageUrl",
                type: {
                    name: "String"
                }
            },
            videoUrl: {
                serializedName: "VideoUrl",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            },
            concept: {
                serializedName: "Concept",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsConceptInfoDto"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            introDate: {
                required: true,
                serializedName: "IntroDate",
                type: {
                    name: "DateTime"
                }
            },
            discoDate: {
                required: true,
                serializedName: "DiscoDate",
                type: {
                    name: "DateTime"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            permission: {
                serializedName: "Permission",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsProductPermissionDto"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsProductReplacementsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7ProductsProductsDto = {
    serializedName: "StaticMV7ProductsProductsDto",
    type: {
        name: "Composite",
        className: "StaticMV7ProductsProductsDto",
        modelProperties: {
            products: {
                required: true,
                serializedName: "Products",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7ProductsProductDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7SettingsCategoryFacetsDto = {
    serializedName: "StaticMV7SettingsCategoryFacetsDto",
    type: {
        name: "Composite",
        className: "StaticMV7SettingsCategoryFacetsDto",
        modelProperties: {
            categoryId: {
                serializedName: "CategoryId",
                type: {
                    name: "String"
                }
            },
            facetNames: {
                required: true,
                serializedName: "FacetNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticMV7SettingsFacetSettingsDto = {
    serializedName: "StaticMV7SettingsFacetSettingsDto",
    type: {
        name: "Composite",
        className: "StaticMV7SettingsFacetSettingsDto",
        modelProperties: {
            categoryFacets: {
                required: true,
                serializedName: "CategoryFacets",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticMV7SettingsCategoryFacetsDto"
                        }
                    }
                }
            },
            defaultFacetNames: {
                required: true,
                serializedName: "DefaultFacetNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            outletFacetNames: {
                required: true,
                serializedName: "OutletFacetNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            sampleShopFacetNames: {
                required: true,
                serializedName: "SampleShopFacetNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            newsFacetNames: {
                required: true,
                serializedName: "NewsFacetNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticNavigationNavigationItemDto = {
    serializedName: "StaticNavigationNavigationItemDto",
    type: {
        name: "Composite",
        className: "StaticNavigationNavigationItemDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            linkType: {
                required: true,
                serializedName: "LinkType",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            nodeId: {
                serializedName: "NodeId",
                type: {
                    name: "String"
                }
            },
            hasChildren: {
                required: true,
                serializedName: "HasChildren",
                type: {
                    name: "Boolean"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticNavigationNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticNavigationNavigationCollectionDto = {
    serializedName: "StaticNavigationNavigationCollectionDto",
    type: {
        name: "Composite",
        className: "StaticNavigationNavigationCollectionDto",
        modelProperties: {
            navigationCollection: {
                required: true,
                serializedName: "NavigationCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticNavigationNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticNavigationNavigationTagDto = {
    serializedName: "StaticNavigationNavigationTagDto",
    type: {
        name: "Composite",
        className: "StaticNavigationNavigationTagDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticNavigationNavigationTagsCollectionDto = {
    serializedName: "StaticNavigationNavigationTagsCollectionDto",
    type: {
        name: "Composite",
        className: "StaticNavigationNavigationTagsCollectionDto",
        modelProperties: {
            tagsCollection: {
                required: true,
                serializedName: "TagsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticNavigationNavigationTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticNotificationsLocalizationDto = {
    serializedName: "StaticNotificationsLocalizationDto",
    type: {
        name: "Composite",
        className: "StaticNotificationsLocalizationDto",
        modelProperties: {
            defaultLanguage: {
                serializedName: "DefaultLanguage",
                type: {
                    name: "String"
                }
            },
            translations: {
                required: true,
                serializedName: "Translations",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Dictionary",
                            value: {
                                type: {
                                    name: "String"
                                }
                            }
                        }
                    }
                }
            },
            contents: {
                required: true,
                serializedName: "Contents",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Dictionary",
                            value: {
                                type: {
                                    name: "String"
                                }
                            }
                        }
                    }
                }
            },
            cultures: {
                required: true,
                serializedName: "Cultures",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Object"
                        }
                    }
                }
            }
        }
    }
};
export var StaticOlapicOlapicConfigurationDto = {
    serializedName: "StaticOlapicOlapicConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticOlapicOlapicConfigurationDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            apiKey: {
                serializedName: "ApiKey",
                type: {
                    name: "String"
                }
            },
            languageCode: {
                serializedName: "LanguageCode",
                type: {
                    name: "String"
                }
            },
            scriptUrl: {
                serializedName: "ScriptUrl",
                type: {
                    name: "String"
                }
            },
            instance: {
                serializedName: "Instance",
                type: {
                    name: "String"
                }
            },
            itemName: {
                serializedName: "ItemName",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            categoryId: {
                serializedName: "CategoryId",
                type: {
                    name: "String"
                }
            },
            hideCaption: {
                required: true,
                serializedName: "HideCaption",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticPageMetaDataPageCustomMetaDataDto = {
    serializedName: "StaticPageMetaDataPageCustomMetaDataDto",
    type: {
        name: "Composite",
        className: "StaticPageMetaDataPageCustomMetaDataDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            content: {
                serializedName: "Content",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticPageMetaDataPageMetaImageDto = {
    serializedName: "StaticPageMetaDataPageMetaImageDto",
    type: {
        name: "Composite",
        className: "StaticPageMetaDataPageMetaImageDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            width: {
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            },
            height: {
                serializedName: "Height",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticPageMetaDataPageMetaRobotsDto = {
    serializedName: "StaticPageMetaDataPageMetaRobotsDto",
    type: {
        name: "Composite",
        className: "StaticPageMetaDataPageMetaRobotsDto",
        modelProperties: {
            follow: {
                required: true,
                serializedName: "Follow",
                type: {
                    name: "Boolean"
                }
            },
            index: {
                required: true,
                serializedName: "Index",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticPageMetaDataPageMetaDataDto = {
    serializedName: "StaticPageMetaDataPageMetaDataDto",
    type: {
        name: "Composite",
        className: "StaticPageMetaDataPageMetaDataDto",
        modelProperties: {
            browserTitle: {
                serializedName: "BrowserTitle",
                type: {
                    name: "String"
                }
            },
            searchTitle: {
                serializedName: "SearchTitle",
                type: {
                    name: "String"
                }
            },
            sharingThumbnail: {
                serializedName: "SharingThumbnail",
                type: {
                    name: "Composite",
                    className: "StaticPageMetaDataPageMetaImageDto"
                }
            },
            sharingDescription: {
                serializedName: "SharingDescription",
                type: {
                    name: "String"
                }
            },
            sharingTitle: {
                serializedName: "SharingTitle",
                type: {
                    name: "String"
                }
            },
            sharingUrl: {
                serializedName: "SharingUrl",
                type: {
                    name: "String"
                }
            },
            category: {
                serializedName: "Category",
                type: {
                    name: "String"
                }
            },
            section: {
                serializedName: "Section",
                type: {
                    name: "String"
                }
            },
            visibility: {
                serializedName: "Visibility",
                type: {
                    name: "String"
                }
            },
            segment: {
                serializedName: "Segment",
                type: {
                    name: "String"
                }
            },
            spo: {
                serializedName: "Spo",
                type: {
                    name: "String"
                }
            },
            iosSmartAppBanner: {
                serializedName: "IosSmartAppBanner",
                type: {
                    name: "String"
                }
            },
            androidSmartAppBanner: {
                serializedName: "AndroidSmartAppBanner",
                type: {
                    name: "String"
                }
            },
            robots: {
                serializedName: "Robots",
                type: {
                    name: "Composite",
                    className: "StaticPageMetaDataPageMetaRobotsDto"
                }
            },
            customMetaData: {
                required: true,
                serializedName: "CustomMetaData",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticPageMetaDataPageCustomMetaDataDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticPopularProductsPopularProductDto = {
    serializedName: "StaticPopularProductsPopularProductDto",
    type: {
        name: "Composite",
        className: "StaticPopularProductsPopularProductDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticPopularProductsProductCollectionDto = {
    serializedName: "StaticPopularProductsProductCollectionDto",
    type: {
        name: "Composite",
        className: "StaticPopularProductsProductCollectionDto",
        modelProperties: {
            productCollection: {
                required: true,
                serializedName: "ProductCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticPopularProductsPopularProductDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductIndexItemsProductIndexItemsDto = {
    serializedName: "StaticProductIndexItemsProductIndexItemsDto",
    type: {
        name: "Composite",
        className: "StaticProductIndexItemsProductIndexItemsDto",
        modelProperties: {
            productIndexItems: {
                required: true,
                serializedName: "ProductIndexItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticControllersProductIndexItemsProductIndexItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsReplacementDto = {
    serializedName: "StaticProductsReplacementDto",
    type: {
        name: "Composite",
        className: "StaticProductsReplacementDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticProductsAvailabilityDto = {
    serializedName: "StaticProductsAvailabilityDto",
    type: {
        name: "Composite",
        className: "StaticProductsAvailabilityDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            isNoLongerForSale: {
                required: true,
                serializedName: "IsNoLongerForSale",
                type: {
                    name: "Boolean"
                }
            },
            isSoldOut: {
                required: true,
                serializedName: "IsSoldOut",
                type: {
                    name: "Boolean"
                }
            },
            isOutOfStock: {
                required: true,
                serializedName: "IsOutOfStock",
                type: {
                    name: "Boolean"
                }
            },
            isNotSoldOnline: {
                required: true,
                serializedName: "IsNotSoldOnline",
                type: {
                    name: "Boolean"
                }
            },
            isComingSoon: {
                required: true,
                serializedName: "IsComingSoon",
                type: {
                    name: "Boolean"
                }
            },
            isLowStock: {
                required: true,
                serializedName: "IsLowStock",
                type: {
                    name: "Boolean"
                }
            },
            isOffer: {
                required: true,
                serializedName: "IsOffer",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            },
            isSuperDeal: {
                required: true,
                serializedName: "IsSuperDeal",
                type: {
                    name: "Boolean"
                }
            },
            isLastChance: {
                required: true,
                serializedName: "IsLastChance",
                type: {
                    name: "Boolean"
                }
            },
            isUntilStockLasts: {
                required: true,
                serializedName: "IsUntilStockLasts",
                type: {
                    name: "Boolean"
                }
            },
            isBundle: {
                required: true,
                serializedName: "IsBundle",
                type: {
                    name: "Boolean"
                }
            },
            isBackorder: {
                required: true,
                serializedName: "IsBackorder",
                type: {
                    name: "Boolean"
                }
            },
            isSalesLimited: {
                required: true,
                serializedName: "IsSalesLimited",
                type: {
                    name: "Boolean"
                }
            },
            expectedInbound: {
                serializedName: "ExpectedInbound",
                type: {
                    name: "DateTime"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsSubBrandDto = {
    serializedName: "StaticProductsSubBrandDto",
    type: {
        name: "Composite",
        className: "StaticProductsSubBrandDto",
        modelProperties: {
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                required: true,
                serializedName: "TaxonomyId",
                type: {
                    name: "Number"
                }
            },
            subBrands: {
                required: true,
                serializedName: "SubBrands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsSubBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedImageVariant = {
    serializedName: "StaticSharedImageVariant",
    type: {
        name: "Composite",
        className: "StaticSharedImageVariant",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            width: {
                required: true,
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSharedImage = {
    serializedName: "StaticSharedImage",
    type: {
        name: "Composite",
        className: "StaticSharedImage",
        modelProperties: {
            sizes: {
                required: true,
                serializedName: "Sizes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedImageVariant"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsBrandDto = {
    serializedName: "StaticProductsBrandDto",
    type: {
        name: "Composite",
        className: "StaticProductsBrandDto",
        modelProperties: {
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                required: true,
                serializedName: "TaxonomyId",
                type: {
                    name: "Number"
                }
            },
            subBrands: {
                required: true,
                serializedName: "SubBrands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsSubBrandDto"
                        }
                    }
                }
            },
            productsCount: {
                serializedName: "ProductsCount",
                type: {
                    name: "Number"
                }
            },
            logo: {
                serializedName: "Logo",
                type: {
                    name: "Composite",
                    className: "StaticSharedImage"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsBrandsDto = {
    serializedName: "StaticProductsBrandsDto",
    type: {
        name: "Composite",
        className: "StaticProductsBrandsDto",
        modelProperties: {
            brandsCollection: {
                required: true,
                serializedName: "BrandsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsBundleComponentDto = {
    serializedName: "StaticProductsBundleComponentDto",
    type: {
        name: "Composite",
        className: "StaticProductsBundleComponentDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticProductsCategoryDto = {
    serializedName: "StaticProductsCategoryDto",
    type: {
        name: "Composite",
        className: "StaticProductsCategoryDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                required: true,
                serializedName: "TaxonomyId",
                type: {
                    name: "Number"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            mobileAppImageUrl: {
                serializedName: "MobileAppImageUrl",
                type: {
                    name: "String"
                }
            },
            expirationDateDescription: {
                serializedName: "ExpirationDateDescription",
                type: {
                    name: "String"
                }
            },
            subCategories: {
                required: true,
                serializedName: "SubCategories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsCategoriesDto = {
    serializedName: "StaticProductsCategoriesDto",
    type: {
        name: "Composite",
        className: "StaticProductsCategoriesDto",
        modelProperties: {
            categoriesCollection: {
                required: true,
                serializedName: "CategoriesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsFormattedPriceDto = {
    serializedName: "StaticProductsFormattedPriceDto",
    type: {
        name: "Composite",
        className: "StaticProductsFormattedPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "String"
                }
            },
            basicCatalogueConsultantPrice: {
                serializedName: "BasicCatalogueConsultantPrice",
                type: {
                    name: "String"
                }
            },
            currentPrice: {
                serializedName: "CurrentPrice",
                type: {
                    name: "String"
                }
            },
            currentConsultantPrice: {
                serializedName: "CurrentConsultantPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsConceptFormattedPriceDto = {
    serializedName: "StaticProductsConceptFormattedPriceDto",
    type: {
        name: "Composite",
        className: "StaticProductsConceptFormattedPriceDto",
        modelProperties: {
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticProductsFormattedPriceDto"
                }
            }
        }
    }
};
export var StaticProductsConceptFormattedPricesDto = {
    serializedName: "StaticProductsConceptFormattedPricesDto",
    type: {
        name: "Composite",
        className: "StaticProductsConceptFormattedPricesDto",
        modelProperties: {
            conceptFormattedPriceCollection: {
                required: true,
                serializedName: "ConceptFormattedPriceCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsConceptFormattedPriceDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsExpectedInboundsProductExpectedInboundDto = {
    serializedName: "StaticProductsExpectedInboundsProductExpectedInboundDto",
    type: {
        name: "Composite",
        className: "StaticProductsExpectedInboundsProductExpectedInboundDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            expectedInboundDate: {
                serializedName: "ExpectedInboundDate",
                type: {
                    name: "DateTime"
                }
            },
            expectedInboundLabel: {
                serializedName: "ExpectedInboundLabel",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsExpectedInboundsProductsExpectedInboundsCollectionDto = {
    serializedName: "StaticProductsExpectedInboundsProductsExpectedInboundsCollectionDto",
    type: {
        name: "Composite",
        className: "StaticProductsExpectedInboundsProductsExpectedInboundsCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsExpectedInboundsProductExpectedInboundDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsIngredientsProductIngredientsDto = {
    serializedName: "StaticProductsIngredientsProductIngredientsDto",
    type: {
        name: "Composite",
        className: "StaticProductsIngredientsProductIngredientsDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            ingredients: {
                required: true,
                serializedName: "Ingredients",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsIngredientsProductsIngredientsDto = {
    serializedName: "StaticProductsIngredientsProductsIngredientsDto",
    type: {
        name: "Composite",
        className: "StaticProductsIngredientsProductsIngredientsDto",
        modelProperties: {
            productsIngredients: {
                required: true,
                serializedName: "ProductsIngredients",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsIngredientsProductIngredientsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsManufacturersAddressDto = {
    serializedName: "StaticProductsManufacturersAddressDto",
    type: {
        name: "Composite",
        className: "StaticProductsManufacturersAddressDto",
        modelProperties: {
            countryCode: {
                serializedName: "CountryCode",
                type: {
                    name: "String"
                }
            },
            countryName: {
                serializedName: "CountryName",
                type: {
                    name: "String"
                }
            },
            address1: {
                serializedName: "Address1",
                type: {
                    name: "String"
                }
            },
            address2: {
                serializedName: "Address2",
                type: {
                    name: "String"
                }
            },
            state: {
                serializedName: "State",
                type: {
                    name: "String"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            zipCode: {
                serializedName: "ZipCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsManufacturersProductManufacturerDto = {
    serializedName: "StaticProductsManufacturersProductManufacturerDto",
    type: {
        name: "Composite",
        className: "StaticProductsManufacturersProductManufacturerDto",
        modelProperties: {
            manufacturerId: {
                serializedName: "ManufacturerId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "StaticProductsManufacturersAddressDto"
                }
            }
        }
    }
};
export var StaticProductsManufacturersProductsManufacturersDto = {
    serializedName: "StaticProductsManufacturersProductsManufacturersDto",
    type: {
        name: "Composite",
        className: "StaticProductsManufacturersProductsManufacturersDto",
        modelProperties: {
            manufacturers: {
                required: true,
                serializedName: "Manufacturers",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsManufacturersProductManufacturerDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsPermissionDto = {
    serializedName: "StaticProductsPermissionDto",
    type: {
        name: "Composite",
        className: "StaticProductsPermissionDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            canDisplay: {
                required: true,
                serializedName: "CanDisplay",
                type: {
                    name: "Boolean"
                }
            },
            canBuy: {
                required: true,
                serializedName: "CanBuy",
                type: {
                    name: "Boolean"
                }
            },
            canSell: {
                required: true,
                serializedName: "CanSell",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticProductsPriceDto = {
    serializedName: "StaticProductsPriceDto",
    type: {
        name: "Composite",
        className: "StaticProductsPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                required: true,
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "Number"
                }
            },
            currentPrice: {
                required: true,
                serializedName: "CurrentPrice",
                type: {
                    name: "Number"
                }
            },
            basicCatalogueConsultantPrice: {
                serializedName: "BasicCatalogueConsultantPrice",
                type: {
                    name: "Number"
                }
            },
            currentConsultantPrice: {
                serializedName: "CurrentConsultantPrice",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticProductsProductBundleDto = {
    serializedName: "StaticProductsProductBundleDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductBundleDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bundleComponents: {
                required: true,
                serializedName: "BundleComponents",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsBundleComponentDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsProductBundlesDto = {
    serializedName: "StaticProductsProductBundlesDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductBundlesDto",
        modelProperties: {
            productBundles: {
                required: true,
                serializedName: "ProductBundles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsProductBundleDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsProductDto = {
    serializedName: "StaticProductsProductDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productType: {
                required: true,
                serializedName: "ProductType",
                type: {
                    name: "String"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            inci: {
                serializedName: "Inci",
                type: {
                    name: "String"
                }
            },
            shadeName: {
                serializedName: "ShadeName",
                type: {
                    name: "String"
                }
            },
            hexColors: {
                required: true,
                serializedName: "HexColors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            colorImageId: {
                serializedName: "ColorImageId",
                type: {
                    name: "String"
                }
            },
            volume: {
                serializedName: "Volume",
                type: {
                    name: "Number"
                }
            },
            volumeUnitText: {
                serializedName: "VolumeUnitText",
                type: {
                    name: "String"
                }
            },
            imageId: {
                serializedName: "ImageId",
                type: {
                    name: "String"
                }
            },
            alternativeImageIds: {
                required: true,
                serializedName: "AlternativeImageIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            videoId: {
                serializedName: "VideoId",
                type: {
                    name: "String"
                }
            },
            manufacturerIds: {
                required: true,
                serializedName: "ManufacturerIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            sampleProductCode: {
                serializedName: "SampleProductCode",
                type: {
                    name: "String"
                }
            },
            dimensionsText: {
                serializedName: "DimensionsText",
                type: {
                    name: "String"
                }
            },
            parentProductCodes: {
                required: true,
                serializedName: "ParentProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            relatedProductCodes: {
                required: true,
                serializedName: "RelatedProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            isOffStock: {
                serializedName: "IsOffStock",
                type: {
                    name: "Boolean"
                }
            },
            length: {
                serializedName: "Length",
                type: {
                    name: "Number"
                }
            },
            height: {
                serializedName: "Height",
                type: {
                    name: "Number"
                }
            },
            depth: {
                serializedName: "Depth",
                type: {
                    name: "Number"
                }
            },
            weight: {
                serializedName: "Weight",
                type: {
                    name: "Number"
                }
            },
            isActive: {
                serializedName: "IsActive",
                type: {
                    name: "Boolean"
                }
            },
            introDate: {
                serializedName: "IntroDate",
                type: {
                    name: "DateTime"
                }
            },
            discoDate: {
                serializedName: "DiscoDate",
                type: {
                    name: "DateTime"
                }
            },
            validityDaysAfterDisco: {
                serializedName: "ValidityDaysAfterDisco",
                type: {
                    name: "Number"
                }
            },
            itemCategory: {
                serializedName: "ItemCategory",
                type: {
                    name: "String"
                }
            },
            barcode: {
                serializedName: "Barcode",
                type: {
                    name: "String"
                }
            },
            keyIngredients: {
                required: true,
                serializedName: "KeyIngredients",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            volumeText: {
                serializedName: "VolumeText",
                type: {
                    name: "String"
                }
            },
            euroMonitorClassId: {
                serializedName: "EuroMonitorClassId",
                type: {
                    name: "String"
                }
            },
            isProductCustomized: {
                serializedName: "IsProductCustomized",
                type: {
                    name: "Boolean"
                }
            },
            replacementFor: {
                serializedName: "ReplacementFor",
                type: {
                    name: "String"
                }
            },
            replacedBy: {
                serializedName: "ReplacedBy",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsProductFormattedPriceDto = {
    serializedName: "StaticProductsProductFormattedPriceDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductFormattedPriceDto",
        modelProperties: {
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            formattedPrice: {
                serializedName: "FormattedPrice",
                type: {
                    name: "Composite",
                    className: "StaticProductsFormattedPriceDto"
                }
            }
        }
    }
};
export var StaticProductsProductFormattedPricesDto = {
    serializedName: "StaticProductsProductFormattedPricesDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductFormattedPricesDto",
        modelProperties: {
            productFormattedPriceCollection: {
                required: true,
                serializedName: "ProductFormattedPriceCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsProductFormattedPriceDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsProductLabelContentDto = {
    serializedName: "StaticProductsProductLabelContentDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductLabelContentDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            helpText: {
                serializedName: "HelpText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsProductLabelsContentCollectionDto = {
    serializedName: "StaticProductsProductLabelsContentCollectionDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductLabelsContentCollectionDto",
        modelProperties: {
            productLabelsContentCollection: {
                required: true,
                serializedName: "ProductLabelsContentCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsProductLabelContentDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsProductLabelsDto = {
    serializedName: "StaticProductsProductLabelsDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductLabelsDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productsLabelsCollection: {
                required: true,
                serializedName: "ProductsLabelsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            productLabelDomain: {
                required: true,
                serializedName: "ProductLabelDomain",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticProductsProductPriceDto = {
    serializedName: "StaticProductsProductPriceDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "StaticProductsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticProductsProductsLabelsDto = {
    serializedName: "StaticProductsProductsLabelsDto",
    type: {
        name: "Composite",
        className: "StaticProductsProductsLabelsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsProductLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsRelation = {
    serializedName: "StaticProductsRelation",
    type: {
        name: "Composite",
        className: "StaticProductsRelation",
        modelProperties: {
            relationType: {
                required: true,
                serializedName: "RelationType",
                type: {
                    name: "String"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsRelationsDto = {
    serializedName: "StaticProductsRelationsDto",
    type: {
        name: "Composite",
        className: "StaticProductsRelationsDto",
        modelProperties: {
            relations: {
                required: true,
                serializedName: "Relations",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsRelation"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsReplacementsReplacementDto = {
    serializedName: "StaticProductsReplacementsReplacementDto",
    type: {
        name: "Composite",
        className: "StaticProductsReplacementsReplacementDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticProductsReplacementsProductReplacementDto = {
    serializedName: "StaticProductsReplacementsProductReplacementDto",
    type: {
        name: "Composite",
        className: "StaticProductsReplacementsProductReplacementDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsReplacementsReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticProductsReplacementsProductsReplacementsDto = {
    serializedName: "StaticProductsReplacementsProductsReplacementsDto",
    type: {
        name: "Composite",
        className: "StaticProductsReplacementsProductsReplacementsDto",
        modelProperties: {
            productReplacementCollection: {
                required: true,
                serializedName: "ProductReplacementCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticProductsReplacementsProductReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSampleSampleDto = {
    serializedName: "StaticSampleSampleDto",
    type: {
        name: "Composite",
        className: "StaticSampleSampleDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                isConstant: true,
                serializedName: "Type",
                defaultValue: 'Sample',
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedGraphQlErrorDto = {
    serializedName: "StaticSharedGraphQlErrorDto",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlErrorDto",
        modelProperties: {
            message: {
                serializedName: "Message",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticApplicationsFooterBffFooterDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticApplicationsFooterBffFooterDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticApplicationsFooterBffFooterDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFooterBffFooterDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticApplicationsFrontpageV3BffFrontPageDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticApplicationsFrontpageV3BffFrontPageDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticApplicationsFrontpageV3BffFrontPageDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsFrontpageV3BffFrontPageDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticApplicationsProductBoxProductBoxDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticApplicationsProductBoxProductBoxDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticApplicationsProductBoxProductBoxDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticApplicationsProductBoxProductBoxDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ConceptsConceptsDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ConceptsConceptsDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ConceptsConceptsDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ConceptsConceptsDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ConceptsHashCodesConceptsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ConceptsHashCodesConceptsHashCodesDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ConceptsHashCodesConceptsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ConceptsHashCodesConceptsHashCodesDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ConceptsLabelsConceptsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ConceptsLabelsConceptsLabelsResponseDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ConceptsLabelsConceptsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ConceptsLabelsConceptsLabelsResponseDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ProductsHashCodesProductsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ProductsHashCodesProductsHashCodesDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ProductsHashCodesProductsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsHashCodesProductsHashCodesDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ProductsLabelsProductsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ProductsLabelsProductsLabelsResponseDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ProductsLabelsProductsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsLabelsProductsLabelsResponseDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ProductsPricesProductsPricesDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ProductsPricesProductsPricesDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ProductsPricesProductsPricesDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsPricesProductsPricesDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSharedGraphQlResponseDto1StaticMV7ProductsProductsDtoStaticVersion1000CultureneutralPublicKeyTokennull = {
    serializedName: "StaticSharedGraphQlResponseDto`1__StaticMV7ProductsProductsDto, Static, Version=1000, Culture=neutral, PublicKeyToken=null__",
    type: {
        name: "Composite",
        className: "StaticSharedGraphQlResponseDto1StaticMV7ProductsProductsDtoStaticVersion1000CultureneutralPublicKeyTokennull",
        modelProperties: {
            data: {
                serializedName: "Data",
                type: {
                    name: "Composite",
                    className: "StaticMV7ProductsProductsDto"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSharedGraphQlErrorDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticShoppingOrderTrackingStepDto = {
    serializedName: "StaticShoppingOrderTrackingStepDto",
    type: {
        name: "Composite",
        className: "StaticShoppingOrderTrackingStepDto",
        modelProperties: {
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            dateTime: {
                serializedName: "DateTime",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var StaticShoppingOrderTrackingsDto = {
    serializedName: "StaticShoppingOrderTrackingsDto",
    type: {
        name: "Composite",
        className: "StaticShoppingOrderTrackingsDto",
        modelProperties: {
            isRealTimeOrderTrackingEnabled: {
                required: true,
                serializedName: "IsRealTimeOrderTrackingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            orderId: {
                required: true,
                serializedName: "OrderId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            currentStatus: {
                serializedName: "CurrentStatus",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            waybillNumber: {
                serializedName: "WaybillNumber",
                type: {
                    name: "String"
                }
            },
            isCourierApiEnabled: {
                required: true,
                serializedName: "IsCourierApiEnabled",
                type: {
                    name: "Boolean"
                }
            },
            step1: {
                serializedName: "Step1",
                type: {
                    name: "Composite",
                    className: "StaticShoppingOrderTrackingStepDto"
                }
            },
            step2: {
                serializedName: "Step2",
                type: {
                    name: "Composite",
                    className: "StaticShoppingOrderTrackingStepDto"
                }
            },
            step3: {
                serializedName: "Step3",
                type: {
                    name: "Composite",
                    className: "StaticShoppingOrderTrackingStepDto"
                }
            },
            step4: {
                serializedName: "Step4",
                type: {
                    name: "Composite",
                    className: "StaticShoppingOrderTrackingStepDto"
                }
            },
            step5: {
                serializedName: "Step5",
                type: {
                    name: "Composite",
                    className: "StaticShoppingOrderTrackingStepDto"
                }
            }
        }
    }
};
export var StaticSocialMediaLibraryCategoryDto = {
    serializedName: "StaticSocialMediaLibraryCategoryDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLibraryCategoryDto",
        modelProperties: {
            categoryId: {
                serializedName: "CategoryId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            nameDefault: {
                serializedName: "NameDefault",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSocialMediaLibraryCategoriesDto = {
    serializedName: "StaticSocialMediaLibraryCategoriesDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLibraryCategoriesDto",
        modelProperties: {
            categoriesCollection: {
                required: true,
                serializedName: "CategoriesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSocialMediaLibraryCategoryDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSocialMediaLibraryImageSizeDto = {
    serializedName: "StaticSocialMediaLibraryImageSizeDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLibraryImageSizeDto",
        modelProperties: {
            width: {
                required: true,
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            },
            height: {
                required: true,
                serializedName: "Height",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSocialMediaLibraryImageInfoDto = {
    serializedName: "StaticSocialMediaLibraryImageInfoDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLibraryImageInfoDto",
        modelProperties: {
            imageInfoId: {
                serializedName: "ImageInfoId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            source: {
                serializedName: "Source",
                type: {
                    name: "String"
                }
            },
            isPopular: {
                required: true,
                serializedName: "IsPopular",
                type: {
                    name: "Boolean"
                }
            },
            createdDate: {
                required: true,
                serializedName: "CreatedDate",
                type: {
                    name: "DateTime"
                }
            },
            size: {
                serializedName: "Size",
                type: {
                    name: "Composite",
                    className: "StaticSocialMediaLibraryImageSizeDto"
                }
            },
            categories: {
                required: true,
                serializedName: "Categories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            thumbUrl: {
                serializedName: "ThumbUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSocialMediaLibraryImageInfosDto = {
    serializedName: "StaticSocialMediaLibraryImageInfosDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLibraryImageInfosDto",
        modelProperties: {
            imageInfosCollection: {
                required: true,
                serializedName: "ImageInfosCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSocialMediaLibraryImageInfoDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSocialMediaLinksSocialMediaLink = {
    serializedName: "StaticSocialMediaLinksSocialMediaLink",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLinksSocialMediaLink",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSocialMediaLinksSocialMediaLinkCollectionDto = {
    serializedName: "StaticSocialMediaLinksSocialMediaLinkCollectionDto",
    type: {
        name: "Composite",
        className: "StaticSocialMediaLinksSocialMediaLinkCollectionDto",
        modelProperties: {
            socialMediaLinkCollection: {
                required: true,
                serializedName: "SocialMediaLinkCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSocialMediaLinksSocialMediaLink"
                        }
                    }
                }
            }
        }
    }
};
export var StaticStepsToSuccessStepsToSuccessTaskDto = {
    serializedName: "StaticStepsToSuccessStepsToSuccessTaskDto",
    type: {
        name: "Composite",
        className: "StaticStepsToSuccessStepsToSuccessTaskDto",
        modelProperties: {
            taskId: {
                serializedName: "TaskId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            detail: {
                serializedName: "Detail",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticStepsToSuccessAllStepsToSuccessPhaseDto = {
    serializedName: "StaticStepsToSuccessAllStepsToSuccessPhaseDto",
    type: {
        name: "Composite",
        className: "StaticStepsToSuccessAllStepsToSuccessPhaseDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticStepsToSuccessStepsToSuccessTaskDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            },
            label: {
                serializedName: "Label",
                type: {
                    name: "String"
                }
            },
            phaseId: {
                serializedName: "PhaseId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticStepsToSuccessAllStepsToSuccessTaskPhasesDto = {
    serializedName: "StaticStepsToSuccessAllStepsToSuccessTaskPhasesDto",
    type: {
        name: "Composite",
        className: "StaticStepsToSuccessAllStepsToSuccessTaskPhasesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticStepsToSuccessAllStepsToSuccessPhaseDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionPackageDto = {
    serializedName: "StaticSubscriptionsSubscriptionPackageDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionPackageDto",
        modelProperties: {
            packageId: {
                required: true,
                serializedName: "PackageId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageSrc: {
                serializedName: "ImageSrc",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionReplacementItemDto = {
    serializedName: "StaticSubscriptionsSubscriptionReplacementItemDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionReplacementItemDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionReplacementDto = {
    serializedName: "StaticSubscriptionsSubscriptionReplacementDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionReplacementDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSubscriptionsSubscriptionReplacementItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionReplacementsDto = {
    serializedName: "StaticSubscriptionsSubscriptionReplacementsDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionReplacementsDto",
        modelProperties: {
            productReplacementCollection: {
                required: true,
                serializedName: "ProductReplacementCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSubscriptionsSubscriptionReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionTypeDto = {
    serializedName: "StaticSubscriptionsSubscriptionTypeDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionTypeDto",
        modelProperties: {
            typeId: {
                required: true,
                serializedName: "TypeId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            category: {
                required: true,
                serializedName: "Category",
                type: {
                    name: "String"
                }
            },
            packages: {
                required: true,
                serializedName: "Packages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSubscriptionsSubscriptionPackageDto"
                        }
                    }
                }
            },
            isSubscriptionEnabled: {
                required: true,
                serializedName: "IsSubscriptionEnabled",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StaticSubscriptionsSubscriptionTypesDto = {
    serializedName: "StaticSubscriptionsSubscriptionTypesDto",
    type: {
        name: "Composite",
        className: "StaticSubscriptionsSubscriptionTypesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticSubscriptionsSubscriptionTypeDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticSystemIdentityServerEndpointsDto = {
    serializedName: "StaticSystemIdentityServerEndpointsDto",
    type: {
        name: "Composite",
        className: "StaticSystemIdentityServerEndpointsDto",
        modelProperties: {
            identityUrl: {
                serializedName: "IdentityUrl",
                type: {
                    name: "String"
                }
            },
            apiUrl: {
                serializedName: "ApiUrl",
                type: {
                    name: "String"
                }
            },
            internalIdentityUrl: {
                serializedName: "InternalIdentityUrl",
                type: {
                    name: "String"
                }
            },
            internalApiUrl: {
                serializedName: "InternalApiUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticSystemOnlineEndpointsDto = {
    serializedName: "StaticSystemOnlineEndpointsDto",
    type: {
        name: "Composite",
        className: "StaticSystemOnlineEndpointsDto",
        modelProperties: {
            onlineUrl: {
                serializedName: "OnlineUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticTagsTagDto = {
    serializedName: "StaticTagsTagDto",
    type: {
        name: "Composite",
        className: "StaticTagsTagDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            translation: {
                serializedName: "Translation",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                required: true,
                serializedName: "TaxonomyId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var StaticTagsTagGroupDto = {
    serializedName: "StaticTagsTagGroupDto",
    type: {
        name: "Composite",
        className: "StaticTagsTagGroupDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            translation: {
                serializedName: "Translation",
                type: {
                    name: "String"
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticTagsTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticTagsTagGroupsDto = {
    serializedName: "StaticTagsTagGroupsDto",
    type: {
        name: "Composite",
        className: "StaticTagsTagGroupsDto",
        modelProperties: {
            tagGroupsCollection: {
                required: true,
                serializedName: "TagGroupsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticTagsTagGroupDto"
                        }
                    }
                }
            }
        }
    }
};
export var StaticTermsTermHtmlDto = {
    serializedName: "StaticTermsTermHtmlDto",
    type: {
        name: "Composite",
        className: "StaticTermsTermHtmlDto",
        modelProperties: {
            termId: {
                serializedName: "TermId",
                type: {
                    name: "String"
                }
            },
            version: {
                serializedName: "Version",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            header: {
                serializedName: "Header",
                type: {
                    name: "String"
                }
            },
            body: {
                serializedName: "Body",
                type: {
                    name: "String"
                }
            },
            footer: {
                serializedName: "Footer",
                type: {
                    name: "String"
                }
            },
            contentUrl: {
                serializedName: "ContentUrl",
                type: {
                    name: "String"
                }
            },
            termsSource: {
                required: true,
                serializedName: "TermsSource",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticTestTestDto = {
    serializedName: "StaticTestTestDto",
    type: {
        name: "Composite",
        className: "StaticTestTestDto",
        modelProperties: {
            content: {
                serializedName: "Content",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticThirdPartyConfigurationAppInsightsDto = {
    serializedName: "StaticThirdPartyConfigurationAppInsightsDto",
    type: {
        name: "Composite",
        className: "StaticThirdPartyConfigurationAppInsightsDto",
        modelProperties: {
            instrumentationKey: {
                serializedName: "InstrumentationKey",
                type: {
                    name: "String"
                }
            },
            isFetchTrackingDisabled: {
                required: true,
                serializedName: "IsFetchTrackingDisabled",
                type: {
                    name: "Boolean"
                }
            },
            samplingPercentage: {
                required: true,
                serializedName: "SamplingPercentage",
                type: {
                    name: "Number"
                }
            },
            endpointUrl: {
                serializedName: "EndpointUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticThirdPartyConfigurationGtmDto = {
    serializedName: "StaticThirdPartyConfigurationGtmDto",
    type: {
        name: "Composite",
        className: "StaticThirdPartyConfigurationGtmDto",
        modelProperties: {
            gtmId: {
                serializedName: "GtmId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticThirdPartyConfigurationOneTrustDto = {
    serializedName: "StaticThirdPartyConfigurationOneTrustDto",
    type: {
        name: "Composite",
        className: "StaticThirdPartyConfigurationOneTrustDto",
        modelProperties: {
            scriptId: {
                serializedName: "ScriptId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticThirdPartyConfigurationSalesManagoDto = {
    serializedName: "StaticThirdPartyConfigurationSalesManagoDto",
    type: {
        name: "Composite",
        className: "StaticThirdPartyConfigurationSalesManagoDto",
        modelProperties: {
            salesManagoId: {
                serializedName: "SalesManagoId",
                type: {
                    name: "String"
                }
            },
            trackingCode: {
                serializedName: "TrackingCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var StaticThirdPartyConfigurationThirdPartyConfigurationDto = {
    serializedName: "StaticThirdPartyConfigurationThirdPartyConfigurationDto",
    type: {
        name: "Composite",
        className: "StaticThirdPartyConfigurationThirdPartyConfigurationDto",
        modelProperties: {
            oneTrust: {
                serializedName: "OneTrust",
                type: {
                    name: "Composite",
                    className: "StaticThirdPartyConfigurationOneTrustDto"
                }
            },
            gtm: {
                serializedName: "Gtm",
                type: {
                    name: "Composite",
                    className: "StaticThirdPartyConfigurationGtmDto"
                }
            },
            appInsights: {
                serializedName: "AppInsights",
                type: {
                    name: "Composite",
                    className: "StaticThirdPartyConfigurationAppInsightsDto"
                }
            },
            salesManago: {
                serializedName: "SalesManago",
                type: {
                    name: "Composite",
                    className: "StaticThirdPartyConfigurationSalesManagoDto"
                }
            }
        }
    }
};

//# sourceMappingURL=mappers.js.map
